<template>
    <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
        <div class="col col-md-6 offset-md-3">
            <div class="alert alert-danger" role="alert">
                <h4 class="alert-heading">Registro de Orden de Operacion</h4>        
                <hr>
                <p v-if=" (cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'FINANCIERO') "> Operaciones realizadas por las Unidades </p>
                <p v-else> Realizado por la Unidad {{ cDtsUser.name_port | capitalize }}</p>
            </div>
        </div>
            

            <nav>
                <div class="nav nav-pills" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-init-traffic" data-toggle="tab" href="#nav-init" role="tab" aria-controls="nav-home" aria-selected="true">1. Inicio ORDOP</a>
                    <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#nav-init-modify" role="tab" aria-controls="nav-home" aria-selected="true" v-if="cDtsUser.roleAssign !== 'OPERADOR'">1.1 Modificar ORDOP</a>
                    <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#nav-init-person" role="tab" aria-controls="nav-home" aria-selected="true" v-if="cDtsUser.roleAssign !== 'OPERADOR'">1.2. Añadir Personas ORDOP</a>
                    <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#nav-init-ordop" role="tab" aria-controls="nav-home" aria-selected="true">1.3. Ejecucion de ORDOPS</a>
                    <a class="nav-item nav-link" id="nav-upload-docu" data-toggle="tab" href="#nav-upload-doc" role="tab" aria-controls="nav-home" aria-selected="true">2. Añadir Digital</a>
                    <a class="nav-item nav-link" id="nav-second-traffic" data-toggle="tab" href="#nav-second" role="tab" aria-controls="nav-profile" aria-selected="false">3. Conclusión ORDOP</a>
                    <a class="nav-item nav-link" id="nav-second-traffic" data-toggle="tab" href="#nav-second-edit" role="tab" aria-controls="nav-profile" aria-selected="false" v-if="cDtsUser.roleAssign !== 'OPERADOR'">2.1 Edición Resultado</a>
                    <a class="nav-item nav-link" id="nav-tirdh-traffic" data-toggle="tab" href="#nav-tirdh" role="tab" aria-controls="nav-profile" aria-selected="false">4. Cierre ORDOP</a>
                </div>
            </nav>
            

            <div class="tab-content" id="nav-tabContent">
                <br>            
                <div class="tab-pane fade show active" id="nav-init" role="tabpanel" aria-labelledby="nav-home-tab">
                    
                    <h6>GENERALES DE LA ORDOP</h6>
                    <!-- <button class="btn btn-info" @click="mRellenaDtsAux"><font-awesome-icon icon="check-square" /> Rellenar Logistica, Comunicacion</button> -->
                    <hr>
                    <transition name="fade" mode="out-in">
                    <div class="form-row" v-if=" (cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'FINANCIERO') ">
                        <div class="form-group col-12 col-md-4 offset-md-4">
                            <label for="nombre_embarcacion">Unidad</label>  
                            <!-- listar las capitanias -->
                            <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="captain_ordop">
                                <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>                         
                        </div>
                        <!-- <div class="col-12" align="center">
                            <button class="btn btn-info" @click="mRellenaFormInit"><font-awesome-icon icon="check-square" /> Rellenar Formulario</button>
                        </div> -->
                    </div>
                    </transition>
                    <!-- ORDOP PRINCIPAL PARA QUE REGISTREN SI CORRESPONDE LA CONTRIBUYENTE -->
                    
                    <div class="input-group mb-3 col-md-10 offset-md-1">
        
                        <label class="form-control" for="nombre_embarcacion">ORDOP emanada por el Comando de la Armada</label>  
                            <!-- listar las capitanias -->
                        <select name="ordop_superior" class="form-control" id="ordop_superior" v-model="ordop_master_select">
                                <option :value="{id:0}">NINGUNO</option>
                                <option v-for="ordm in ordop_master" :value="ordm" :key="ordm.id">{{ ordm.titulo_superior }}</option>
                        </select> 
                        
                        <div class="input-group-append">
                            <button class="btn btn-outline-success" :disabled="animate_master" @click="mCallOrdopsSuperior">
                                <font-awesome-icon icon="sync-alt" :spin="animate_master"/>
                            </button>            
                        </div>
                    </div>
                    
                    <div class="form-row" >
                        <div class="form-group col-12 col-md-4 offset-md-4">
                                                    
                        </div>
                    </div>
                    
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="ordop_title">Nombre ORDOP <span class="required-text">*</span></label>
                            <input type="text" v-model="dts_ordop.title" class="form-control" id="ordop_title" placeholder="BALA"  autocomplete="off">
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="date_init_ordop">Tipo Operacion <span class="required-text">*</span></label>
                            <select name="tipo_ordop_init" id="tipo_ordop_init" class="form-control" v-model="dts_ordop.tipo_init">
                                <option v-for="to in tipos_ordop" :key="to.id" :value="to.id">{{to.detail}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="type_ordop">Categoria de ORDOP <span class="required-text">*</span></label>
                            <select name="type_ordop" class="form-control" id="type_ordop" v-model="dts_ordop.type" @click="mSelectType">
                                <option v-for="or in types_ordop_init" :value="or.id" :key="or.id">{{or.detail}}</option>
                            </select>
                        </div>
                        
                        <div class="form-group col-12 col-md-3">
                            <label for="date_init_ordop">Fecha Inicio <span class="required-text">*</span></label>
                            <datetime v-model="dts_ordop.date_init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                            <!-- <input v-model="dts_ordop.date_init" type="date" class="form-control" name="date_init_ordop" > -->
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="time_init_ordop">Hora Inicio <span class="required-text">*</span></label>
                            <datetime v-model="time_init_aux" type="time" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" placeholder="Seleccione Hora" title="Hora de Inicio" value-zone="America/La_Paz"></datetime>
                            <!-- <input type="number" v-model="dts_ordop.time_init" class="form-control" name="time_init_ordop" > -->
                        </div>
                        <!-- <div class="form-group col-12 col-md-3">
                            <label for="date_end_ordop">Fecha Conclusion </label>
                            <input v-model="dts_ordop.date_end" type="date" class="form-control" name="date_end_ordop" >
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="time_end_ordop">Hora Conclusion</label>
                            <input type="number" v-model="dts_ordop.time_end" class="form-control" name="time_end_ordop" >
                        </div> -->
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-12">
                            <label for="task_ordop">Situación <span class="required-text">*</span>  En FH:{{ cHoraMilitaryInit }}</label>           
                            <textarea v-model="dts_ordop.situation" class="form-control" id="situacion_ordop" placeholder="de acuerdo a informacion"  autocomplete="off"></textarea>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-12">
                            <label for="task_ordop"><span class="required-text">*</span>(Misión)</label>           
                            <textarea v-model="dts_ordop.task" class="form-control" id="task_ordop" placeholder="Realizar Controles........."  autocomplete="off"></textarea>
                        </div>
                    </div>

                    <!-- <div class="form-row">
                        <div class="form-group col-12 col-md-12">
                            <label for="purpose_ordop">Proposito <span class="required-text">*</span> (A FIN DE)</label>           
                            <textarea type="text" v-model="dts_ordop.purpose" class="form-control" id="purpose_ordop" placeholder="Identificar y neutralizar ........"  autocomplete="off"></textarea>
                        </div>
                    </div> -->

                    <!-- <div class="form-row">
                        <div class="form-group col-12 col-md-12">
                            <label for="exec_ordop">Ejecución <span class="required-text">*</span></label>           
                            <textarea type="text" v-model="dts_ordop.execution" class="form-control" id="purpose_ordop" placeholder="Esta Unidad"  autocomplete="off"></textarea>
                        </div>
                    </div> -->

                    <h6>PERSONAL Y MEDIOS</h6>
                    <hr>
                    <div class="form-row">
                        <div class="form-group col-12 col-md-3">
                            <label for="bandera_embarcacion">Oficiales Superiores</label>
                            <input type="number" v-model="dts_ordop.osup" class="form-control" name="flag_ship" >
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="bandera_embarcacion">Oficiales Subalternos</label>
                            <input type="number" v-model="dts_ordop.osub" class="form-control" name="flag_ship" >
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="bandera_embarcacion">Suboficiales</label>
                            <input type="number" v-model="dts_ordop.so" class="form-control" name="flag_ship" >
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="bandera_embarcacion">Sargentos</label>
                            <input type="number" v-model="dts_ordop.sgto" class="form-control" name="flag_ship" >
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="bandera_embarcacion">Marineros</label>
                            <input type="number" v-model="dts_ordop.mar" class="form-control" name="flag_ship" >
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="bandera_embarcacion">Medios Terrestres</label>
                            <input type="number" v-model="dts_ordop.vehicle" class="form-control" name="flag_ship" >
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="bandera_embarcacion">Medios Acuaticos</label>
                            <input type="number" v-model="dts_ordop.ship" class="form-control" name="flag_ship" >
                        </div>                        
                    </div>

                    <div class="form-row">
                        <label for="organizacion_ordop">Organización<span class="required-text">*</span></label>
                        <div class="input-group mb-3">
                            <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="port_select_person" @change="mChangePersonalCaptain(2)">
                                <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>   
                            <select class="custom-select" id="inputPersonSelect" v-model="person_select">
                                <option v-for="pc in persons_captain" :key="pc.personal_id" :value="pc">{{ pc.grade }} {{ pc.speciality }} {{ pc.complete }}</option>
                            </select>
                            <input type="text" class="form-control" placeholder="Cargo o Rol" aria-label="Cargo o Rol en operacion" aria-describedby="button-addon2" v-model="charge_temp">
                            <div class="input-group-append">
                                <button class="btn btn-outline-success" type="button" id="button-addon2" @click="mAppendPerson"><font-awesome-icon icon="plus" /></button>
                            </div>
                        </div>
                    </div>

                    
                            <label for="bandera_embarcacion">Listado de Personal incluido en la ORDOP<span class="required-text">*</span></label>
                            <div class="table-responsive col-12">
                                <table class="table table-sm" v-if="person_selecteds_ordop.length > 0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Grado y Nombre</th>
                                            <th>Cargo o Rol</th>
                                            <th>Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(pso, index) in person_selecteds_ordop" :key="pso.personal_id">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ pso.complete }}</td>
                                            <td>{{ pso.charge }}</td>
                                            <td><button class="btn btn-danger" @click="mDeleteList(index)"><font-awesome-icon icon="minus-circle" /></button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                <!-- <h6>COORDINACIÓN, LOGÍSTICA Y COMUNICACIÓN</h6>
                <hr>
                <div class="form-row">
                        <label for="organizacion_ordop">Instrucciones de Coordinación<span class="required-text">*</span></label>
                        <textarea type="text" class="form-control" placeholder="En caso de surgir una contigencia ..." aria-label="En caso de surgir ......" aria-describedby="button-addon2" v-model="dts_ordop.coordinacion"></textarea>
                </div> -->

                <!-- <hr> -->
                <!-- <div class="form-row">
                        <label for="organizacion_ordop">Administración y Logística<span class="required-text">*</span></label>
                        <textarea type="text" class="form-control" placeholder="AdministracionLog" aria-label="A cargo de la sección IV Logistica" aria-describedby="button-addon2" v-model="dts_ordop.middle"></textarea>
                </div> -->
                <!-- aqui registramos las comunicaciones -->
                <!-- <hr> -->
                <!-- <div class="form-row">
                        <label for="organizacion_ordop">Comunicaciones<span class="required-text">*</span></label>
                        <textarea type="text" class="form-control" placeholder="AdministracionLog" aria-label="A cargo de la sección IV Logistica" aria-describedby="button-addon2" v-model="dts_ordop.comunication"></textarea>
                </div> -->

                <!-- <div class="form-row">
                    <div class="form-group col-12 col-md-5">
                        <label for="year_exec">Seleccione Rio o Lago de Operacion</label>
                        
                        <multiselect v-model="lake_select" :options="list_lake" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Seleccione sectores Operacion" label="name_lake" track-by="id" :selectLabel="options_select.selectLabel" :selectedLabel="options_select.selectedLabel" :deselectLabel="options_select.deselectLabel">
                            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} item(s) seleccionado(s)</span></template>
                        </multiselect>                     
                    </div>
                    <transition name="fade" mode="out-in">
                    <div class="form-group col-12 col-md-6" v-if="lake_select.length > 0">
                        <label for="month-select">Item(s) Seleccionado(s)</label>
                        <div>
                            <h5><span class="badge badge-success" v-for="m in lake_select" :key="m.id"> {{ m.name_lake }} </span></h5>
                        </div>
                    </div>
                    </transition>
                </div> -->
                <hr>
                <h6 align="left"> 
                    <div class="custom-control custom-switch">
                        <input type="checkbox" v-model="dts_ordop.init" class="custom-control-input" id="customSwitch2" @change="mChangeOrdopSwitch">
                        <label class="custom-control-label" for="customSwitch2"><span :class="dts_ordop.init ? 'alert-success':'alert-danger'">{{value_init_ordop}}</span></label>
                    </div>
                </h6>
                    <p class="required-text" align="right" style="font-size:12px;">Campos Obligatorios (*)</p>
                    <button class="btn btn-outline-danger col-12 col-md-4 offset-md-4" :disabled="btn_r_ordop" @click="saveOrdop">
                        <font-awesome-icon icon="save" size="3x" />
                    </button>
                </div>
                <!-- end first tab traffic -->
                
                <div v-if="cDtsUser.roleAssign !== 'OPERADOR'" class="tab-pane fade"  id="nav-init-modify" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Edición ORDOP</h4>        
                        <hr>
                        <p>En esta pantalla usted podra modificar una Orden de Operacion aun Activa.</p>
                    </div>
                    <transition name="fade" mode="out-in">
                    <div class="form-row" v-if="cDtsUser.role !== 4">
                        <div class="form-group col-12 col-md-4 offset-md-4">
                            <label for="nombre_embarcacion">Unidad</label>  
                            <!-- listar las capitanias -->
                            <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="captain_ordop" @change="mClearForm">
                                <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>                         
                        </div>
                        <div class="col-12" align="center">
                            <button class="btn btn-success" @click="mCallOrdopsEdit"><font-awesome-icon icon="list" /> Listar ORDOPS</button>
                        </div>    
                    </div>
                    <div class="form-row" v-else>
                        <div class="col-12" align="center">
                            <button class="btn btn-success" @click="mCallOrdopsEdit"><font-awesome-icon icon="list" /> Listar ORDOPS</button>
                        </div>                        
                    </div>
                    </transition>
                    <br><br>
                    <div class="form-row" v-if="ordops_edit.length > 0">
                         <div class="form-group col-12">
                            <label for="type_identification" class="labelBlack">Listado ORDOP</label>
                            <select name="ordop_select_process" class="form-control" id="ordop_select_process" v-model="ordop_select_edit" @change="mCallOrdopsVigentEdit">
                                <option v-for="op in ordops_edit" :value="op" :key="op.id">{{ op.titulo_ordop }} - ({{ op.tipo_ordop }} ) ({{ op.tipo_ordop }} )</option>
                            </select>
                        </div>
                    </div>
            <div v-if="dts_ordop_edit.id_ordop>0">
                    <h6>GENERALES DE LA ORDOP A MODIFICAR</h6>
                    <hr>
                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="ordop_title">Nombre ORDOP <span class="required-text">*</span></label>
                            <input type="text" v-model="dts_ordop_edit.title" class="form-control" id="ordop_title" placeholder="BALA"  autocomplete="off">
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="type_ordop">Tipo de ORDOP <span class="required-text">*</span></label>
                            <select name="type_ordop" class="form-control" id="type_ordop" v-model="dts_ordop_edit.type">
                                <option v-for="or in types_ordop_init" :value="or.id" :key="or.id">{{or.detail}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-3">
                            <label for="date_init_ordop">Tipo Operación <span class="required-text">*</span></label>
                            <select name="edit_tipo_ordop" id="edit_tipo_ordop" class="form-control" v-model="dts_ordop_edit.tipo_init">
                                <option v-for="toe in tipos_ordop" :value="toe.id" :key="toe.id">{{ toe.detail  }}</option>
                            </select>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="date_init_ordop">Fecha Inicio <span class="required-text">*</span></label>
                            <datetime v-model="dts_ordop_edit.date_init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                            <!-- <input v-model="dts_ordop_edit.date_init" type="date" class="form-control" name="date_init_ordop" > -->
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="time_init_ordop">Hora Inicio <span class="required-text">*</span></label>
                            <datetime v-model="time_init_aux_edit" type="time" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" placeholder="Seleccione Hora" title="Hora de Inicio" value-zone="America/La_Paz"></datetime>
                            <!-- <input type="number" v-model="dts_ordop_edit.time_init" class="form-control" name="time_init_ordop" > -->
                        </div>
                        <!-- <div class="form-group col-12 col-md-3">
                            <label for="date_end_ordop">Fecha Conclusion </label>
                            <input v-model="dts_ordop_edit.date_end" type="date" class="form-control" name="date_end_ordop" >
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="time_end_ordop">Hora Conclusion</label>
                            <input type="number" v-model="dts_ordop_edit.time_end" class="form-control" name="time_end_ordop" >
                        </div> -->
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-12">
                            <label for="task_ordop">Situación <span class="required-text">*</span> En FH:{{ cHoraMilitaryEdit }}  </label>           
                            <textarea v-model="dts_ordop_edit.situation" class="form-control" id="situacion_ordop" placeholder="de acuerdo a informacion"  autocomplete="off"></textarea>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-12">
                            <label for="task_ordop">Tarea <span class="required-text">*</span>(Misión)</label>           
                            <textarea v-model="dts_ordop_edit.task" class="form-control" id="task_ordop" placeholder="Realizar Controles........."  autocomplete="off"></textarea>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-12">
                            <label for="purpose_ordop">Proposito <span class="required-text">*</span> (A FIN DE)</label>           
                            <textarea type="text" v-model="dts_ordop_edit.purpose" class="form-control" id="purpose_ordop" placeholder="Identificar y neutralizar ........"  autocomplete="off"></textarea>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-12">
                            <label for="exec_ordop">Ejecución <span class="required-text">*</span></label>           
                            <textarea type="text" v-model="dts_ordop_edit.execution" class="form-control" id="purpose_ordop" placeholder="Esta Unidad"  autocomplete="off"></textarea>
                        </div>
                    </div>

                    <h6>PERSONAL Y MEDIOS</h6>
                    <hr>
                    <div class="form-row">
                        <div class="form-group col-12 col-md-3">
                            <label for="bandera_embarcacion">Oficiales Superiores</label>
                            <input type="number" v-model="dts_ordop_edit.osup" class="form-control" name="flag_ship" >
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="bandera_embarcacion">Oficiales Subalternos</label>
                            <input type="number" v-model="dts_ordop_edit.osub" class="form-control" name="flag_ship" >
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="bandera_embarcacion">Suboficiales</label>
                            <input type="number" v-model="dts_ordop_edit.so" class="form-control" name="flag_ship" >
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="bandera_embarcacion">Sargentos</label>
                            <input type="number" v-model="dts_ordop_edit.sgto" class="form-control" name="flag_ship" >
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="bandera_embarcacion">Marineros</label>
                            <input type="number" v-model="dts_ordop_edit.mar" class="form-control" name="flag_ship" >
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="bandera_embarcacion">Medios Terrestres</label>
                            <input type="number" v-model="dts_ordop_edit.vehicle" class="form-control" name="flag_ship" >
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="bandera_embarcacion">Medios Acuaticos</label>
                            <input type="number" v-model="dts_ordop_edit.ship" class="form-control" name="flag_ship" >
                        </div>                        
                    </div>

                    <div class="form-row">
                        <label for="organizacion_ordop">Organización<span class="required-text">*</span></label>
                        <div class="input-group mb-3">
                            <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="port_select_person_edit" @change="mChangePersonalCaptainEdit(2)">
                                <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>   
                            <select class="custom-select" id="inputPersonSelect" v-model="person_select">
                                <option v-for="pc in persons_captain" :key="pc.personal_id" :value="pc">{{ pc.grade }} {{ pc.speciality }} {{ pc.complete }}</option>
                            </select>
                            <input type="text" class="form-control" placeholder="Cargo o Rol" aria-label="Cargo o Rol en operacion" aria-describedby="button-addon2" v-model="charge_temp">
                            <div class="input-group-append">
                                <button class="btn btn-outline-success" type="button" id="button-addon2" @click="mAppendPersonEdit"><font-awesome-icon icon="plus" /></button>
                            </div>
                        </div>
                    </div>

                    
                            <label for="bandera_embarcacion">Listado de Personal incluido en la ORDOP<span class="required-text">*</span></label>
                            <div class="table-responsive col-12">
                                <table class="table table-sm" v-if="person_selecteds_ordop_edit.length > 0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Grado y Nombre</th>
                                            <th>Cargo o Rol</th>
                                            <th>Eliminar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(pso, index) in person_selecteds_ordop_edit" :key="pso.personal_id">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ pso.complete }}</td>
                                            <td>{{ pso.charge }}</td>
                                            <td><button class="btn btn-danger" @click="mDeleteListEdit(index)"><font-awesome-icon icon="minus-circle" /></button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                <h6>COORDINACIÓN, LOGÍSTICA Y COMUNICACIÓN</h6>
                <hr>
                <div class="form-row">
                        <label for="organizacion_ordop">Instrucciones de Coordinación<span class="required-text">*</span></label>
                        <textarea type="text" class="form-control" placeholder="En caso de surgir una contigencia ..." aria-label="En caso de surgir ......" aria-describedby="button-addon2" v-model="dts_ordop_edit.coordinacion"></textarea>
                </div>

                <hr>
                <div class="form-row">
                        <label for="organizacion_ordop">Administración y Logística<span class="required-text">*</span></label>
                        <textarea type="text" class="form-control" placeholder="AdministracionLog" aria-label="A cargo de la sección IV Logistica" aria-describedby="button-addon2" v-model="dts_ordop_edit.middle"></textarea>
                </div>
                <!-- aqui registramos las comunicaciones -->
                <hr>
                <div class="form-row">
                        <label for="organizacion_ordop">Comunicaciones<span class="required-text">*</span></label>
                        <textarea type="text" class="form-control" placeholder="AdministracionLog" aria-label="A cargo de la sección IV Logistica" aria-describedby="button-addon2" v-model="dts_ordop_edit.comunication"></textarea>
                </div>

                <div class="form-row">
                    <div class="form-group col-12 col-md-5">
                        <label for="year_exec">Seleccione Rio o Lago de Operacion</label>
                        
                        <multiselect v-model="lake_select_edit" :options="list_lake" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Seleccione el Mes" label="name_lake" track-by="id" :selectLabel="options_select.selectLabel" :selectedLabel="options_select.selectedLabel" :deselectLabel="options_select.deselectLabel">
                            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} item(s) seleccionado(s)</span></template>
                        </multiselect>                     
                    </div>
                    <transition name="fade" mode="out-in">
                    <div class="form-group col-12 col-md-6" v-if="lake_select_edit.length > 0">
                        <label for="month-select">Item(s) Seleccionado(s)</label>
                        <div>
                            <h5><span class="badge badge-success" v-for="m in lake_select_edit" :key="m.id"> {{ m.name_lake }} </span></h5>
                        </div>
                    </div>
                    </transition>
                </div>

                    <p class="required-text" align="right" style="font-size:12px;">Campos Obligatorios (*)</p>
                    <button class="btn btn-outline-warning col-12 col-md-4 offset-md-4" :disabled="btn_r_ordop_edit" @click="saveOrdopEdit">
                        <font-awesome-icon icon="sync-alt" size="3x" />
                    </button>
                </div>
                </div>
            
                <!-- ejecucion de ordops -->
                <div class="tab-pane fade" id="nav-init-ordop" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Ejecucion de ORDOPS</h4>        
                        <hr>
                        <p>En esta pantalla usted podra indicar si la ORDOP se encuentra en Ejecución o No se estaria operando la ORDOP Activandolo y Desactivandolo a traves de las opciones</p>
                    </div>
                    <h6>EJECUCION O NO DE ORDOPS</h6>
                    <hr>
                    <transition name="fade" mode="out-in">
                    <div class="form-row" v-if="cDtsUser.role !== 4">
                        <div class="form-group col-12 col-md-4 offset-md-4">
                            <label for="nombre_embarcacion">Unidad</label>  
                            <!-- listar las capitanias -->
                            <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="captain_ordop" @change="mClearForm">
                                <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>                         
                        </div>
                        <div class="col-12" align="center">
                            <button class="btn btn-success" @click="mCallOrdopsVigentExecution"><font-awesome-icon icon="list" /> Listar ORDOPS</button>
                        </div>                        
                    </div>
                    <div class="form-row" v-else>
                        <div class="col-12" align="center">
                            <button class="btn btn-success" @click="mCallOrdopsVigentExecution"><font-awesome-icon icon="list" /> Listar ORDOPS</button>
                        </div>                        
                    </div>
                    </transition>
                    <br><br>
                    <div class="table-responsive" v-if="ordops_execution.length > 0">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th align="center">#</th>
                                    <th align="center">Nombre ORDOP</th>
                                    <th align="center">Estado</th>
                                    <th align="center">Habilitar/Inhabilitar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(orvig, key) in ordops_execution" :key="orvig.id">
                                    <td >{{ key+1 }}</td>
                                    <td >{{ orvig.titulo_ordop }}</td>

                                    <td v-if="orvig.ejecucion_vigente==='S'" class="alert alert-success">ORDOP en Ejecución</td>
                                    <td v-else class="alert alert-warning">NO esta en Ejecución</td>

                                    <td align="center">
                                        <button class="btn btn-success" v-if="orvig.ejecucion_vigente==='S'" @click="mChangeState(orvig.id, key)"><font-awesome-icon icon="toggle-on" size="lg" /></button>
                                        <button class="btn btn-danger" v-else @click="mChangeState(orvig.id, key)"><font-awesome-icon icon="toggle-off" size="lg" /></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                </div>

                <div v-if="cDtsUser.roleAssign !== 'OPERADOR'" class="tab-pane fade" id="nav-init-person" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Inclusión de Personal</h4>        
                        <hr>
                        <p>En esta pantalla usted podra incluir, excluir personal que va participando en la ORDOP</p>
                    </div>
                    <h6>AÑADIR o INCLUIR PERSONAS ORDOP</h6>
                    <hr>
                    <transition name="fade" mode="out-in">
                    <div class="form-row" v-if="cDtsUser.role !== 4">
                        <div class="form-group col-12 col-md-4 offset-md-4">
                            <label for="nombre_embarcacion">Unidad</label>  
                            <!-- listar las capitanias -->
                            <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="captain_ordop" @change="mClearForm">
                                <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>                         
                        </div>
                        <div class="col-12" align="center">
                            <button class="btn btn-success" @click="mCallOrdopsVigentPersons"><font-awesome-icon icon="list" /> Listar ORDOPS</button>
                        </div>                        
                    </div>
                    <div class="form-row" v-else>
                        <div class="col-12" align="center">
                            <button class="btn btn-success" @click="mCallOrdopsVigentPersons"><font-awesome-icon icon="list" /> Listar ORDOPS</button>
                        </div>                        
                    </div>
                    </transition>
                    <br><br>
                    <div class="form-row" v-if="ordops_persons.length > 0">
                         <div class="form-group col-12">
                            <label for="type_identification" class="labelBlack">Listado ORDOP</label>
                            <select name="ordop_select_process" class="form-control" id="ordop_select_process" v-model="ordop_select_persons" @change="mSelectOrdopPerson">
                                <option v-for="op in ordops_persons" :value="op" :key="op.id">{{ op.titulo_ordop }} - ({{ op.tipo_ordop }} ) ({{ op.tipo_ordop }} )</option>
                            </select>
                        </div>
                    </div>
                    <transition name="fade" mode="out-in">
                    <div v-if="select_ordop_person">
                        <div class="form-row">
                            <label for="staticEmail" class="labelBlack">Titulo ORDOP</label>    
                            <input type="text" readonly class="form-control-plaintext" id="staticTitleOrdop" v-model="process_ordop_person.title">    
                        </div>
                        <div class="form-row">
                            <label for="staticEmail" class="labelBlack">Tarea ORDOP</label>    
                            <input type="text" readonly class="form-control-plaintext" id="staticTitleOrdop" v-model="process_ordop_person.task">
                        </div>
                        
                        <div class="form-row">
                            <div class="form-group col-12 col-md-3">
                                <label for="time_init_ordop" class="labelBlack">Fecha Inicio</label>
                                <input type="text" readonly class="form-control-plaintext" v-model="date_init_aux_person" name="time_init_ordop" >
                            </div>
                        </div>
                        <!-- aqui va el nuevo personal a incluir -->

                    <div class="form-row">
                        <label for="organizacion_ordop">Añadir Personal a la ORDOP<span class="required-text">*</span></label>
                        <div class="input-group mb-3">
                            <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="port_select_person_new" @change="mChangePersonalCaptainNew(2)">
                                <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>   
                            <select class="custom-select" id="inputPersonSelect" v-model="person_select_new">
                                <option v-for="pc in persons_captain_new" :key="pc.personal_id" :value="pc">{{ pc.grade }} {{ pc.speciality }} {{ pc.complete }}</option>
                            </select>
                            <input type="text" class="form-control" placeholder="Cargo o Rol" aria-label="Cargo o Rol en operacion" aria-describedby="button-addon2" v-model="charge_temp_new">
                            <div class="input-group-append">
                                <button class="btn btn-outline-success" type="button" id="button-addon2"  @click="mAppendPersonNew"><font-awesome-icon icon="plus" /></button>
                            </div>
                        </div>
                    </div>
                        <!-- aqui listamos al personal que ya fue incluido en el primer registro  -->
                        <label for="bandera_embarcacion">Listado de Personal incluido en la ORDOP<span class="required-text">*</span></label>
                            <div class="table-responsive col-12">
                                <table class="table table-sm" v-if="process_ordop_person.persons_old.length > 0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Grado y Nombre</th>
                                            <th>Cargo o Rol</th>
                                            <th>Orden Impresion</th>
                                            <th>Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(pso, index) in process_ordop_person.persons_old" :key="pso.personal_id">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ pso.complete }}</td>
                                            <td>{{ pso.charge }}</td>
                                            <td>                    
                                                <div v-if="!pso.is_edit"> {{ pso.order }} </div>                            
                                                <input type="number" class="form-control col-md-5" v-else v-model="persons_old_temp.order" min="1" />
                                            </td>
                                            <td>
                                                <div class="input-group mb-3">
                                                    <div class="input-group-append" v-if="!pso.is_edit">
                                                        <button class="btn btn-outline-primary" type="button" @click="mEditPersonOld(index)" ><font-awesome-icon icon="edit" /></button>
                                                        <button class="btn btn-outline-danger" v-if="pso.type==='N'" type="button" @click="mDeleteListNew(index)"><font-awesome-icon icon="minus-circle" /></button>
                                                    </div>
                                                
                                                    <div class="input-group-append" v-else>
                                                        <button class="btn btn-outline-success" type="button" @click="mSavePersonOld(index)"><font-awesome-icon icon="save" /></button>
                                                        <button class="btn btn-outline-danger" type="button" @click="mCancelEditPersonOld(index)"><font-awesome-icon icon="times-circle" /></button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    

                        <!-- fin de los antiguos personal -->
                        <p class="required-text" align="right" style="font-size:12px;">Campos Obligatorios (*)</p>
                        <button class="btn btn-outline-warning col-12 col-md-4 offset-md-4" :disabled="btn_u_newp" @click="mSavePersonsAdd">
                            <font-awesome-icon icon="sync-alt" size="3x" />
                        </button>

                    </div>
                    </transition>
                </div>
                
                <!-- tab que sube el documento digital de la ORDOP -->
                <div class="tab-pane fade" id="nav-upload-doc" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Inclusión Archivo Digital</h4>        
                        <hr>
                        <p>En esta pantalla usted podra añadir a la ORDOP su archivo Digital</p>
                    </div>
                    <h6>Añadir el archivo digital</h6>
                    <hr>
                    <transition name="fade" mode="out-in">
                    <div class="form-row" v-if="cDtsUser.role !== 4">
                        <div class="form-group col-12 col-md-3 offset-md-3">
                            <label for="nombre_embarcacion">Unidad</label>  
                            <!-- listar las capitanias -->
                            <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="captain_ordop" @change="mClearForm">
                                <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>                         
                        </div>
                        
                        <div class="form-group col-12 col-md-4">
                            <label for="time_init_ordop">Gestion </label>
                            <select name="year_r" id="year_r" class="form-control" v-model="gestion">
                                <option v-for="y in gestiones" :value="y.c" :key="y.c" :selected="y.c==gestion">{{ y.c }}</option>
                            </select>
                        </div>
                        
                        <div class="col-12" align="center">
                            <button class="btn btn-success" @click="mCallOrdopsDocuments"><font-awesome-icon icon="list" /> Listar ORDOPS</button>
                        </div>                        
                    </div>
                    <div class="form-row" v-else>
                        
                        <div class="form-group col-12 col-md-4 offset-md-4">
                            <label for="time_init_ordop">Gestion </label>
                            <select name="year_r" id="year_r" class="form-control" v-model="gestion">
                                <option v-for="y in gestiones" :value="y.c" :key="y.c" :selected="y.c==gestion">{{ y.c }}</option>
                            </select>
                        </div>
                        
                        <div class="col-12" align="center">
                            <button class="btn btn-success" @click="mCallOrdopsDocuments"><font-awesome-icon icon="list" /> Listar ORDOPS</button>
                        </div>                        
                    </div>
                    </transition>
                    <br><br>
                    <div class="form-row" v-if="ordops_persons.length > 0">
                         <div class="form-group col-12">
                            <label for="type_identification" class="labelBlack">Listado ORDOP</label>
                            <select name="ordop_select_process" class="form-control" id="ordop_select_process" v-model="ordop_document" @change="mSelectOrdopDocument">
                                <option v-for="op in ordops_persons" :value="op" :key="op.id">{{ op.titulo_ordop }} - ({{ op.tipo_ordop }} ) ({{ op.tipo_ordop }} )</option>
                            </select>
                        </div>
                    </div>
                    <transition name="fade" mode="out-in">
                    <div v-if="ordop_document_select.id>0">
                        <div class="form-row">
                            <label for="staticEmail" class="labelBlack">Titulo ORDOP</label>    
                            <input type="text" readonly class="form-control-plaintext" id="staticTitleOrdop" v-model="ordop_document_select.titulo_ordop">    
                        </div>
                        <div class="form-row">
                            <label for="staticEmail" class="labelBlack">Tipo ORDOP</label>    
                            <input type="text" readonly class="form-control-plaintext" id="staticTitleOrdop" v-model="ordop_document_select.tipo_ordop">
                        </div>
                        
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label for="tarea_ordop" class="labelBlack">tarea ORDOP</label>
                                <input type="text" readonly class="form-control-plaintext" v-model="ordop_document_select.tarea" name="tarea_ordop" >
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <label for="fileArchivoMensaje" class="labelBlack">Archivo Digital</label>
                            <input type="file" class="form-control-file" id="fileArchivoMensaje" @change="handleFileUpload" accept=".pdf">
                        </div>
                        <!-- aqui va el nuevo personal a incluir -->
                        <!-- fin de los antiguos personal -->
                        <p class="required-text" align="right" style="font-size:12px;">Campos Obligatorios (*)</p>
                        <button class="btn btn-outline-warning col-12 col-md-4 offset-md-4" :disabled="btn_u_newp" @click="mRegisterTarea">
                            <font-awesome-icon icon="upload" size="3x" />
                        </button>

                    </div>
                    <!-- end div que contiene todo para subir el archivo -->
                    </transition>
                </div>
                
                <!-- init tab second results -->
                <div class="tab-pane fade" id="nav-second" role="tabpanel" aria-labelledby="nav-profile-tab">
                    
                    <h6>BUSQUEDA ORDOP PARA REGISTRO DE RESULTADOS</h6>
                    <hr>
                    <transition name="fade" mode="out-in">
                    <div class="form-row" v-if="cDtsUser.role !== 4">
                        <div class="form-group col-12 col-md-4 offset-md-4">
                            <label for="nombre_embarcacion">Unidad</label>  
                            <!-- listar las capitanias -->
                            <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="captain_ordop" @change="mClearForm">
                                <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>                         
                        </div>
                        <div class="col-12" align="center">
                            <button class="btn btn-info" :disabled="!select_ordop" @click="mRellenarFormProcess"><font-awesome-icon icon="check-square" /> Rellenar Formulario</button>
                            <button class="btn btn-success" @click="mCallOrdopsVigent"><font-awesome-icon icon="list" /> Listar ORDOPS</button>
                        </div>                        
                    </div>
                    <div class="form-row" v-else>
                        <div class="col-12" align="center">
                            <button class="btn btn-success" @click="mCallOrdopsVigent"><font-awesome-icon icon="list" /> Listar ORDOPS</button>
                        </div>                        
                    </div>
                    </transition>
                    <br><br>
                    <div class="form-row" v-if="ordops.length > 0">
                         <div class="form-group col-12">
                            <label for="type_identification" class="labelBlack">Listado ORDOP</label>
                            <select name="ordop_select_process" class="form-control" id="ordop_select_process" v-model="ordop_select_process" @change="mSelectOrdop">
                                <option v-for="op in ordops" :value="op" :key="op.id">{{ op.titulo_ordop }} - ({{ op.tipo_ordop }} ) ({{ op.tipo_ordop }} )</option>
                            </select>
                        </div>
                        <!-- <div class="form-group col-12 col-md-9"> -->
                            <!-- <input type="text" name="search_property" id="" class="form-control form-control-sm" placeholder="Propietario"> -->
                            
                            <!-- <vue-bootstrap-typeahead                            
                                        v-model="query_ordop"
                                        :data="ordops"
                                        size="sm"
                                        :serializer="item => (item.titulo_ordop +' ('+item.tipo_ordop+') ('+item.tarea+')')"
                                        @hit="mSelectOrdop"
                                        :placeholder="searchOrdop"                                        
                            /> -->
                        <!-- </div> -->
                    </div>
                    <transition name="fade" mode="out-in">
                    <div v-if="select_ordop">
                        <div class="form-row">
                            <label for="staticEmail" class="labelBlack">Titulo ORDOP</label>    
                            <input type="text" readonly class="form-control-plaintext" id="staticTitleOrdop" v-model="process_ordop.title">    
                        </div>
                        <div class="form-row">
                            <label for="staticEmail" class="labelBlack">Tarea ORDOP</label>    
                            <input type="text" readonly class="form-control-plaintext" id="staticTitleOrdop" v-model="process_ordop.task">
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="type_ordop" class="labelBlack">Tipo de Resultado</label>
                                <select name="type_ordop" class="form-control" id="type_ordop" v-model="type_select" @click="mSelectType">
                                    <option v-for="or in types_ordop" :value="or" :key="or.id">{{or.detail}}</option>
                                </select>
                            </div>

                                <div class="form-group col-12 col-md-5" v-if="type_load">
                                    <div v-if="!is_select_load">
                                    <label for="conclusions" class="labelBlack">Tipo Carga obtenida en la Operacion <span class="required-text">*</span></label>           
                                    <div v-if="value_load.val">
                                    <vue-bootstrap-typeahead                                        
                                            v-model="load_ordop"
                                            :data="loads_type"
                                            :serializer="item => item.carga_detail"
                                            @hit="mSelectLoadOrdop"
                                            :placeholder="dPlaceLoad"
                                        />
                                    </div>
                                    <div v-else>
                                        <input type="text" class="form-control-plaintext" value="Sin declaracion de Carga">
                                    </div>
                                    </div>
                                    
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" v-model="value_load.val" class="custom-control-input" id="customSwitch1" @change="mChangeLoadSwitch">
                                        <label class="custom-control-label" for="customSwitch1">{{value_load.detail}}</label>
                                    </div>
                                    <!-- <div v-else>                                        
                                        <label for="conclusions" class="labelBlack">Ha Seleccionado</label>
                                        <input type="text" readonly class="form-control-plaintext" id="staticTitleOrdop" v-model="select_load">
                                    </div> -->
                                </div>
                                <button class="btn btn-danger col-12 col-md-1" v-if="is_select_load" @click="mResetLoad"><font-awesome-icon icon="sync-alt" /></button>
                                              
                            <transition name="fade" mode="out-in">
                                <!-- aqui dibujamos el formulario de las cargas con sus respectivas opciones -->
                                <table class="table" v-if="loads_declare.length > 0">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Carga</th>
                                            <th scope="col">Cantidad</th>
                                            <th scope="col">----</th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(l,index) in loads_declare" :key="l.id_load_specify">
                                        <tr>
                                            <td scope="row" width="5%" class="align-middle">{{ index+1 }}</td>
                                            <td width="25%" class="align-middle">{{ l.detail_load }}</td>
                                            <td>
                                                <div>
                                                <div v-if="l.unit === 'C' || l.unit === 'R'" class="form-row" >
                                                    <div class="form-group col-12 col-md-3">
                                                        <label for="input_load"><b>Kilo</b></label>
                                                        <input type="number"  readonly class="form-control-plaintext" v-model="l.kilo" v-if="!l.edit">
                                                        <input :readonly="!load_temp.disabled_quantity" type="number" class="form-control" v-else v-model="load_temp.kilo" @keyup="mCalcKiloTonelada">
                                                    </div>
                                                    <div class="form-group col-12 col-md-3">
                                                        <label for="input_load"><b>Tonelada</b></label>
                                                        <input type="number" v-if="!l.edit" readonly class="form-control-plaintext" v-model="l.ton">
                                                        <input :readonly="!load_temp.disabled_quantity" type="number" class="form-control" v-else v-model="load_temp.ton" @keyup="mCalcToneladaKilo">
                                                    </div>
                                                    <div class="form-group col-12 col-md-3">
                                                        <label for="input_load"><b>Cantidad</b></label>
                                                        <input type="number" v-if="!l.edit" readonly class="form-control-plaintext" v-model="l.quantity">
                                                        <input :readonly="load_temp.disabled_quantity" type="number" class="form-control" v-else v-model="load_temp.quantity">
                                                    </div>
                                                    <div class="form-group col-12 col-md-3">
                                                        <label for="input_load"><b>Unidad de carga</b></label>
                                                        <input type="text" v-if="!l.edit" readonly class="form-control-plaintext" v-model="l.type_aux_load_des">
                                                        <select v-else name="type_aux_load" class="form-control" id="type_ordop" v-model="type_load_aux" @change="mGetTypeLoad">
                                                            <option v-for="tl in type_load_solid" :value="tl" :key="tl.id" :selected="tl.id===load_temp.type_aux_load">{{tl.detail}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div v-if="l.unit === 'L'" class="form-row">
                                                    <div class="form-group col-12 col-md-3">
                                                        <label for="input_load"><b>Litros</b></label>
                                                        <input type="number" v-if="!l.edit" readonly class="form-control-plaintext" v-model="l.liters">
                                                        <input type="number" :readonly="!load_temp.disabled_quantity" class="form-control" v-else v-model="load_temp.liters">
                                                    </div>
                                                    <div class="form-group col-12 col-md-4">
                                                        <label for="input_load"><b>Cantidad</b></label>
                                                        <input type="number" v-if="!l.edit" readonly class="form-control-plaintext" v-model="l.quantity">
                                                        <input type="number" :readonly="load_temp.disabled_quantity" class="form-control" v-else v-model="load_temp.quantity">
                                                    </div>
                                                    <div class="form-group col-12 col-md-3">
                                                        <label for="input_load"><b>Unidad de carga</b></label>
                                                        <input type="text" v-if="!l.edit" readonly class="form-control-plaintext" v-model="l.type_aux_load_des">
                                                        <select v-else name="type_aux_load" class="form-control" id="type_ordop" v-model="type_load_aux" @change="mGetTypeLoad">
                                                            <option v-for="tl in type_load_liquid" :value="tl" :key="tl.id" >{{tl.detail}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div v-if="l.unit === 'P'" class="form-row">
                                                    <div class="form-group col-12 col-md-2">
                                                        <label for="input_load"><b>Varon</b></label>
                                                        <input type="number" v-if="!l.edit" readonly class="form-control-plaintext" v-model="l.man">
                                                        <input type="number" class="form-control" v-else v-model="load_temp.man">
                                                    </div>
                                                    <div class="form-group col-12 col-md-2">
                                                        <label for="input_load"><b>Mujer</b></label>
                                                        <input type="number" v-if="!l.edit" readonly class="form-control-plaintext" v-model="l.woman">
                                                        <input type="number" class="form-control" v-else v-model="load_temp.woman">
                                                    </div>
                                                    <div class="form-group col-12 col-md-2">
                                                        <label for="input_load"><b>Niño</b></label>
                                                        <input type="number" v-if="!l.edit" readonly class="form-control-plaintext" v-model="l.boy">
                                                        <input type="number" class="form-control" v-else v-model="load_temp.boy">
                                                    </div>
                                                    <div class="form-group col-12 col-md-2">
                                                        <label for="input_load"><b>Niña</b></label>
                                                        <input type="number" v-if="!l.edit" readonly class="form-control-plaintext" v-model="l.girl">
                                                        <input type="number" class="form-control" v-else v-model="load_temp.girl">
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="form-group col-12">
                                                        <label for="input_load"><b>Des. Carga</b></label>
                                                        <input type="text" v-if="!l.edit" readonly class="form-control-plaintext" v-model="l.description_load">
                                                        <input type="text" class="form-control" v-else v-model="load_temp.description_load">
                                                    </div>
                                                </div>
                                                </div>
                                            </td>
                                            <td class="align-middle">
                                                <div class="input-group mb-3">
                                                    <div class="input-group-append" v-if="!l.edit">
                                                        <button class="btn btn-outline-primary" type="button" @click="mEditValues(index)" ><font-awesome-icon icon="edit" /></button>
                                                        <button class="btn btn-outline-danger" type="button" @click="mQuitLoad(index)"><font-awesome-icon icon="minus-circle" /></button>
                                                    </div>
                                                
                                                    <div class="input-group-append" v-else>
                                                        <button class="btn btn-outline-success" type="button" @click="mSaveValues(index)"><font-awesome-icon icon="save" /></button>
                                                        <button class="btn btn-outline-danger" type="button" @click="mCancelEditLoad(index)"><font-awesome-icon icon="times-circle" /></button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </transition>

                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-3">
                                <label for="time_init_ordop" class="labelBlack">Fecha Inicio</label>
                                <input type="text" readonly class="form-control-plaintext" v-model="date_init_aux" name="time_init_ordop" >
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="date_end_ordop" class="labelBlack">Fecha Conclusion <span class="required-text">*</span></label>
                                <datetime v-model="process_ordop.date_end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione la Fecha" title="Fecha de Conclusion" value-zone="America/La_Paz"></datetime>
                                <!-- <input v-model="process_ordop.date_end" type="date" class="form-control" name="date_end_ordop" > -->
                            </div>
                            <div class="form-group col-12 col-md-3">
                                <label for="time_end_ordop" class="labelBlack">Hora Conclusion <span class="required-text">*</span></label>
                                <datetime v-model="time_end_aux" type="time" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" placeholder="Indique la Hora" title="Hora Conclusion" value-zone="America/La_Paz"></datetime>
                                <!-- <input type="number" v-model="process_ordop.time_end" class="form-control" name="time_end_ordop" > -->
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-12">
                                <label for="done_ordop" class="labelBlack">Hechos <span class="required-text">*</span></label>           
                                <textarea type="text" v-model="process_ordop.done" class="form-control" id="done_ordop" placeholder="Se encontraba...."  autocomplete="off"></textarea>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-12">
                                <label for="causes_ordop" class="labelBlack">Causas <span class="required-text">*</span></label>           
                                <textarea type="text" v-model="process_ordop.causes" class="form-control" id="causes_ordop" placeholder="La persona se encontraba en estado de ebriedad...."  autocomplete="off"></textarea>
                            </div>
                        </div>
                        
                        <div class="form-row">
                            <div class="form-group col-12 col-md-12">
                                <label for="causes_ordop" class="labelBlack">Consecuencias <span class="required-text">*</span></label>           
                                <textarea type="text" v-model="process_ordop.consequence" class="form-control" id="causes_ordop" placeholder="La persona perdio el equilibrio"  autocomplete="off"></textarea>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-12">
                                <label for="actions_take_ordop" class="labelBlack">Acciones Tomadas <span class="required-text">*</span></label>           
                                <textarea type="text" v-model="process_ordop.actions_taken" class="form-control" id="actions_take_ordop" placeholder="La persona se encontraba en estado de ebriedad...."  autocomplete="off"></textarea>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-12">
                                <label for="conclusions" class="labelBlack">Conclusiones <span class="required-text">*</span></label>           
                                <textarea type="text" v-model="process_ordop.conclusions" class="form-control" id="conclusions" placeholder="La persona se encontraba en estado de ebriedad...."  autocomplete="off"></textarea>
                            </div>
                        </div>
                        
                        <div class="form-row">
                            <div class="form-group col-12 col-md-12">
                                <label for="conclusions" class="labelBlack">Daño u Importe de Incautación <span class="required-text">*</span></label>           
                                <input type="number" v-model="process_ordop.import_dano" class="form-control" id="conclusions" placeholder="0"  autocomplete="off" />
                            </div>
                        </div>

                        <div class="form-row">
                            <!-- aqui va la parte donde indicaran si existio inconvenientes respecto  -->
                            <div class="custom-control custom-switch">
                                <input type="checkbox" v-model="value_inconvenient.val" class="custom-control-input" id="customSwitchInconvenient" @change="mChangeInconvenientSwitch">
                                <label class="custom-control-label" for="customSwitchInconvenient"><span :class="value_inconvenient.val ? 'alert-danger':'alert-success'">{{value_inconvenient.detail}}</span></label>
                            </div>
                        </div>

                        <div class="form-row" v-if="value_inconvenient.val">
                            <div class="form-group col-12 col-md-12">
                                <label for="description_inconvenient" class="labelBlack">Descripcion del Inconveniente  <span class="required-text">*</span></label>           
                                <textarea type="text" v-model="process_ordop.description_problem" class="form-control" id="description_inconvenient" placeholder="Descripcion del inconveniente ..."  autocomplete="off"></textarea>
                            </div>
                            <div class="form-group col-12 col-md-12">
                                <label for="description_solution" class="labelBlack">Descripcion de la solucion al inconveniente  <span class="required-text">*</span></label>           
                                <textarea type="text" v-model="process_ordop.description_solution" class="form-control" id="description_solution" placeholder="Descripcion de la solucion al inconveniente ...."  autocomplete="off"></textarea>
                            </div>
                        </div>

                        <p class="required-text" align="right" style="font-size:12px;">Campos Obligatorios (*)</p>
                        <button class="btn btn-outline-danger col-12 col-md-4 offset-md-4" :disabled="btn_p_ordop" @click="mSaveProcessOrdop">
                            <font-awesome-icon icon="save" size="3x" />
                        </button>

                    </div>
                    </transition>
                </div>
                <!-- end second tab -->

                <!-- edicion de hechos y acciones tomadas considerando el rol de la persona -->
                <div class="tab-pane fade" id="nav-second-edit" role="tabpanel" aria-labelledby="nav-profile-tab" v-if="cDtsUser.roleAssign !== 'OPERADOR'">
                    
                    <h6>BUSQUEDA Y EDICION DE RESULTADOS ORDOP</h6>
                    <hr>
                    <transition name="fade" mode="out-in">
                        <div class="form-row d-print-none">
                            <div class="input-group mb-3 col-md-8 offset-md-2">
                        
                                <select class="form-control" name="year_ordop_a" id="year_ordop_a" v-model="year_select_a">
                                    <option v-for="ya in years" :key="ya.c" :value="ya.c">{{ ya.c }}</option>
                                </select>
                                <select class="form-control" v-if="(cDtsUser.roleAssign !== 'OPERADOR' && cDtsUser.roleAssign !== 'FINANCIERO')" name="capitania_anexo" id="capitania_anexo" v-model="captain_ordop_edit" >
                                    <option v-for="cpa in ports" :key=cpa.id :value="cpa.id">{{ cpa.name_port }}</option>
                                </select>
                                <div class="input-group-prepend" v-else>
                                    <span class="input-group-text" id="">{{cDtsUser.name_port}}</span>
                                </div>                
                                <div class="input-group-append">
                                    <button class="btn btn-outline-success" :disabled="animate_button" @click="mCallOrdopsResultEdit">
                                        <font-awesome-icon icon="sync-alt" :spin="animate_button"/>
                                    </button>            
                                </div>
                            </div>            
                        </div>
                    
                    </transition>
                    <br><br>
                    <div class="form-row" v-if="ordops_edit_result.length > 0">
                         <div class="form-group col-12">
                            <label for="type_identification" class="labelBlack">Listado ORDOP</label>
                            <select name="ordop_select_process" class="form-control" id="ordop_select_process" v-model="ordop_select_edit_result" @change="mCallResults">
                                <option v-for="op in ordops_edit_result" :value="op.id" :key="op.id">{{ op.detail }} - ({{ op.tipo_ordop }} )</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-row" v-if="resultsOrdop.length > 0">
                        <div class="form-group col-12">
                            <label for="type_identification" class="labelBlack">Listado ORDOP</label>
                            <select name="ordop_select_process" class="form-control" id="ordop_select_process" v-model="ordop_select_result" @change="mCallDtsResult">
                                <option v-for="opr in resultsOrdop" :value="opr.id" :key="opr.id">{{ opr.detail }} - ({{ opr.hecho }} )</option>
                            </select>
                        </div>                        
                    </div>
                    <transition name="fade" mode="out-in">
                    <div v-if="process_ordop_edit.id > 0 ">
                        <div class="form-row">
                            <div class="form-group col-12 col-md-12">
                                <label for="done_ordop" class="labelBlack">Hechos <span class="required-text">*</span></label>           
                                <textarea type="text" v-model="process_ordop_edit.done" class="form-control" id="done_ordop" placeholder="Se encontraba...."  autocomplete="off"></textarea>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 col-md-12">
                                <label for="causes_ordop" class="labelBlack">Causas <span class="required-text">*</span></label>           
                                <textarea type="text" v-model="process_ordop_edit.causes" class="form-control" id="causes_ordop" placeholder="La persona se encontraba en estado de ebriedad...."  autocomplete="off"></textarea>
                            </div>
                        </div>
                        
                        <div class="form-row">
                            <div class="form-group col-12 col-md-12">
                                <label for="causes_ordop" class="labelBlack">Consecuencias <span class="required-text">*</span></label>           
                                <textarea type="text" v-model="process_ordop_edit.consequence" class="form-control" id="causes_ordop" placeholder="La persona perdio el equilibrio"  autocomplete="off"></textarea>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-12">
                                <label for="actions_take_ordop" class="labelBlack">Acciones Tomadas <span class="required-text">*</span></label>           
                                <textarea type="text" v-model="process_ordop_edit.actions_taken" class="form-control" id="actions_take_ordop" placeholder="La persona se encontraba en estado de ebriedad...."  autocomplete="off"></textarea>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-12">
                                <label for="conclusions" class="labelBlack">Conclusiones <span class="required-text">*</span></label>           
                                <textarea type="text" v-model="process_ordop_edit.conclusions" class="form-control" id="conclusions" placeholder="La persona se encontraba en estado de ebriedad...."  autocomplete="off"></textarea>
                            </div>
                        </div>

                        <p class="required-text" align="right" style="font-size:12px;">Campos Obligatorios (*)</p>
                        <button class="btn btn-outline-warning col-12 col-md-4 offset-md-4" :disabled="btn_u_ordop" @click="mUpdateProcessOrdop">
                            <font-awesome-icon icon="sync-alt" size="3x" :spin="btn_u_ordop" />
                        </button>

                    </div>
                    </transition>
                </div>
                <!-- cierre de ordop -->
                <div class="tab-pane fade" id="nav-tirdh" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="form-row">
                        
                        <br>
                        <p><small id="emailHelp" class="form-text text-muted">Cierre de aquellos ORDOPS que no fueron finalizados en el paso 2 debiendo contar con al menos un caso</small></p>
                        <br><hr>
                    </div>
                    <transition name="fade" mode="out-in">
                            <div class="form-row" v-if="cDtsUser.role !== 4">
                                <div class="form-group col-12 col-md-4 offset-md-4">
                                    <label for="nombre_embarcacion">Unidad</label>  
                                    <!-- listar las capitanias -->
                                    <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="captain_ordop">
                                        <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                                    </select>                         
                                </div>
                            </div>
                    </transition>
                    <div class="form-row">
                        <button class="btn btn-outline-info col-12 col-md-4 offset-md-4" @click="mListAllOrdops">
                            <font-awesome-icon icon="list" size="2x" />
                        </button>
                    </div>

                    <br><br>
                    <transition name="bounce">
                        <div class="col-12 col-md-10 offset-md-1 table-responsive" v-if="ordops_list.length > 0">
                        <table class="table table-striped">
                            <thead class="thead-dark">
                                <tr>
                                    <th scoped="col">#</th>
                                    <th scoped="col">Titulo ORDOP</th>
                                    <th scoped="col">Tarea</th>
                                    <th scoped="col">Finalizar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(o, index) in ordops_list" :key="o.id">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ o.titulo_ordop }}</td>
                                    <td>{{ o.tarea }}</td>
                                    <td><button class="btn btn-warning" @click="mCloseOrdop(o.id)"><font-awesome-icon icon="check" /></button></td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </transition>
                </div>
                <!-- end tirdth tab -->
            </div>            
        </div>
    <modal-loading :id-modal="id_modal_progress" :title="title_modal" :status-send="send_dispatch" ></modal-loading>
    </div>    
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';

export default {
    name:'ordop',
    mounted(){
        this.verifyCategory();
        this.callCaptains();
        this.getYears();
        // this.mCallTypesCategorys();
    },
    data(){
        return {
            animate_master:false,
            ordop_master:[],
            ordop_master_select:{id:-1},
            gestion:0,
            gestiones:[],
            tipos_ordop:[],
            ordop_select_result:0,
            ordop_select_edit_result:0,
            animate_button:false,
            year_select_a:0,
            years:[],
            options_select:{
                selectLabel:'Seleccionar',
                selectedLabel:'Seleccionado',
                deselectLabel:'Deseleccionar'
            },
            list_lake:[],
            lake_select:[],
            lake_select_edit:[],
            ordop_select_process:{},
            ordop_select_persons:{},
            ordop_document:{},
            ordop_select_edit:{},
            ordop_select:{},
            value_load:{val:true, detail:'con Declaracion'},
            value_inconvenient:{val:false, detail:'Sin Inconvenientes en el Desarrollo de la Operacion'},
            type_load_aux:{id:0},
            select_load:null,
            type_load_liquid:[],
            type_load_solid:[],
            is_select_load:false,
            c_efectiva_persons:false,
            c_efectiva_load_kilo:false,
            c_efectiva_load_litro:false,
            c_efectiva_load_rodada:false,
            load_temp:{
                man:0,
                woman:0,
                boy:0,
                girl:0,
                kilo:0,
                ton:0,
                quantity:0,
                liters:0,
                active:false,
                disabled_quantity:true,
                type_aux_load:0,
                type_aux_load_des:null,
                description_load:null
            },
            load_ordop:null,
            loads_type:[],
            loads_declare:[],
            load_declare_template:null,
            dPlaceLoad:'Carga declarada ORDOP',
            type_load:false,
            types_ordop:[],
            types_ordop_init:[],
            type_select:null,
            time_end_aux:null,
            date_init_aux:null,
            date_init_aux_person:null,
            process_ordop:{
                id:0,
                title:null,
                task:null,
                type_task:0,
                date_init:null,
                date_end:null,
                time_end:null,
                done:null,
                causes:null,
                consequence:null,
                actions_taken:null,
                conclusions:null,
                load:[],
                inconvenient:false,
                description_problem:null,
                description_solution:null,
                import_dano:0
            },
            process_ordop_edit:{
                id:0,
                title:null,
                task:null,
                type_task:0,
                done:null,
                causes:null,
                consequence:null,
                actions_taken:null,
                conclusions:null,
                import_dano:0
            },
            process_ordop_person:{
                id:0,
                title:null,
                task:null,
                type_task:0,
                date_init:null,
                persons_old:[]
            },
            select_ordop:false,
            select_ordop_person:false,
            query_ordop:null,
            ordops:[],
            ordops_persons:[],
            searchOrdop:'Busqueda de ORDOP',
            id_modal_progress:'modal_ordop',
            title_modal:'Registrando',
            send_dispatch:true,
            ports:[],
            captain_ordop:0,
            captain_process_ordop:0,
            time_init_aux:null,
            time_init_aux_edit:null,
            logict_one:'',
            comunication_one:'',
            coordinacion_one:'',
            dts_ordop:{
                title:null,
                type:0,
                tipo_init:0,
                task:null,
                purpose:null,
                date_init:null,
                date_end:null,
                time_init:0,
                time_end:0,
                osup:0,
                osub:0,
                so:0,
                sgto:0,
                mar:0,
                vehicle:0,
                ship:0,
                detail_organization:null,
                middle:null,
                lakes:[],
                logistics:'',
                comunication:'',
                coordinacion:'',
                mensual:false,
                execution:'',
                situation:'',
                init:false,
                id_ordop_master:'',
                titulo_ordop_master:'',
                division_origen:'',
                contribuyente:'N'
            },
            dts_ordop_edit:{
                id_ordop:0,
                title:null,
                type:0,
                tipo_init:0,
                task:null,
                purpose:null,
                date_init:null,
                date_end:null,
                time_init:0,
                time_end:0,
                osup:0,
                osub:0,
                so:0,
                sgto:0,
                mar:0,
                vehicle:0,
                ship:0,
                detail_organization:null,
                middle:null,
                lakes:[],
                logistics:'',
                comunication:'',
                coordinacion:'',
                mensual:false,
                execution:'',
                situation:''
            },
            ordops_edit:[],
            btn_r_ordop:false,
            btn_r_ordop_edit:false,
            btn_u_newp:false,
            btn_p_ordop:false,
            ordops_list:[],
            ordop_select_down:0,
            persons_captain:[],
            persons_captain_new:[],
            person_selecteds_ordop:[],
            person_selecteds_ordop_edit:[],
            person_selecteds_new:[],
            person_select:{},
            person_select_new:{},
            charge_temp:null,
            charge_temp_new:null,
            port_select_person:0,
            port_select_person_edit:0,
            port_select_person_new:0,
            persons_old_temp:{},
            value_init_ordop:'Ejecucion Inactiva',
            ordops_execution:[],
            btn_u_ordop:false,
            resultsOrdop:[],
            captain_ordop_edit:0,
            ordops_edit_result:[],
            ordop_document_select:{},
            select_file:null,
            animacion_file:false
        }
    },
    methods:{
        getYears(){
            let ya=new Date();
            this.gestion=ya.getFullYear();
            
            const init=2015;
            this.gestiones=[];
            for(let i=init; i<=this.gestion; i++){
                let ai={c:i};
                this.gestiones.push(ai);
            }
            // this.dts_millas.date_init=`${ya.getFullYear()}-${ya.getDay()}-${ya.getMonth()}`;
        },
        mValidateDocument(){
            if(this.select_file===null){
                toastr.warning("Debe seleccionar un documento PDF, no mas de 2 MB a enviar al servidor");
                return false;
            }
            return true;
        },
        async mRegisterTarea(){
            try {
            
                if(this.mValidateDocument()){
                    this.animacion_file=true;
                    const formData = new FormData();
                    formData.append('file', this.select_file);
                    formData.append('id_ordop', this.ordop_document_select.id);
                    
                    let regDocument=await axios.post(`regDocument?api_token=${Vue.auth.getToken()}`, formData);
                    if(regDocument.data.status){
                        toastr.success(`${regDocument.data.respuesta}`)
                    }else{
                        toastr.error(`${regDocument.data.respuesta}`)
                    }
                    setTimeout(()=>{
                        this.animacion_file=false;
                    },2000)
                }
                
            } catch (error) {
                console.log(error);
                this.animacion_file=false;
            }
                        
        },
        handleFileUpload(event) {
            const MAXIMO_TAMANIO_BYTES = 2000000; // 1MB = 1 millón de bytes
            let temp_archivo=event.target.files[0];

            if (temp_archivo.size <= MAXIMO_TAMANIO_BYTES) {
                this.select_file = event.target.files[0];
            } else {
                const tamanioEnMb = MAXIMO_TAMANIO_BYTES / 1000000;
                toastr.warning(`El tamaño máximo es ${tamanioEnMb} MB`);
                event.target.value='';
                // Validación pasada. Envía el formulario o haz lo que tengas que hacer
            }
        },
        async mChangeState(idp, idx){
            let nstate;
            if(this.ordops_execution[idx].ejecucion_vigente==='S'){
                this.ordops_execution[idx].ejecucion_vigente='N';
                nstate='N';
            }else{
                this.ordops_execution[idx].ejecucion_vigente='S';
                nstate='S';
            }
            let sordop={
                id_ordop:idp,
                init:nstate
            }
            try {
                let ns=await axios.post(`updateStatusOrdop?api_token=${Vue.auth.getToken()}`, qs.stringify(sordop));    
                if(ns.data.status){
                    toastr.success(`${ns.data.respuesta}`, 'Exito')
                }else{
                    toastr.error(`${ns.data.respuesta}`, 'Error')
                }
            } catch (error) {
                console.log(error)
            }
        },
        mChangeOrdopSwitch(){
            // console.log(this.value_load);
            
            if(this.dts_ordop.init){
                this.dts_ordop.init=true;
                this.value_init_ordop='Ejecucion Activa';
            }else{
                this.dts_ordop.init=false;
                this.value_init_ordop='Ejecucion Inactiva';
                // this.inconvenient={description_problem:'S/D', description_solution:'S/D'};
                // this.process_ordop.inconvenient=false;
            }
        },
        mDeleteListEdit(i){
            
            // let ips2=this.person_selecteds_ordop.findIndex(dts => dts.personal_id === this.person_select.personal_id);
            // if(ips2 >=0){
                // agregamos a la persona
                this.person_selecteds_ordop_edit.splice(i, 1);
            // }
        },
        mDeleteList(i){
            
            // let ips2=this.person_selecteds_ordop.findIndex(dts => dts.personal_id === this.person_select.personal_id);
            // if(ips2 >=0){
                // agregamos a la persona
                this.person_selecteds_ordop.splice(i, 1);
            // }
        },
        mDeleteListNew(i){
            // let ips2=this.person_selecteds_ordop.findIndex(dts => dts.personal_id === this.person_select.personal_id);
            // if(ips2 >=0){
                // agregamos a la persona
                this.process_ordop_person.persons_old.splice(i, 1);
            // }
        },
        async mChangePersonalCaptain(typeSearch=1){
            this.persons_captain=[];
            if(typeSearch===1){
                this.person_selecteds_ordop=[];
                this.person_select={};
                this.charge_temp=null;
            }
            let captain_select=this.port_select_person > 0 ? this.port_select_person : this.captain_ordop;
            let callPers= await axios.get(`personalCaptains/${captain_select}?api_token=${Vue.auth.getToken()}`);
                // console.log(callPers.data);
            this.persons_captain=callPers.data;
        },
        async mChangePersonalCaptainEdit(typeSearch=1){
            this.persons_captain=[];
            if(typeSearch===1){
                this.person_selecteds_ordop_edit=[];
                this.person_select={};
                this.charge_temp=null;
            }
            let captain_select_edit=this.port_select_person_edit > 0 ? this.port_select_person_edit : this.captain_ordop;
            let callPers= await axios.get(`personalCaptains/${captain_select_edit}?api_token=${Vue.auth.getToken()}`);
                // console.log(callPers.data);
            this.persons_captain=callPers.data;
        },
        async mChangePersonalCaptainNew(typeSearch=1){
            this.persons_captain_new=[];
            if(typeSearch===1){
                this.person_selecteds_new=[];
                this.person_select_new={};
                // this.charge_temp=null;
            }
            let captain_select_new=this.port_select_person_new > 0 ? this.port_select_person_new : this.captain_ordop;
            let callPers= await axios.get(`personalCaptains/${captain_select_new}?api_token=${Vue.auth.getToken()}`);
                // console.log(callPers.data);
            this.persons_captain_new=callPers.data;
        },
        mAppendPersonNew(){
            // anadimos a la persona en lista de participantes de la ORDOP
            
            // let ips=this.process_ordop_person.persons_new.findIndex(dts => dts.id_person === this.person_select_new.personal_id);

            let ipo=this.process_ordop_person.persons_old.findIndex(dts => dts.id_person === this.person_select_new.personal_id);
            let countReg=this.process_ordop_person.persons_old.length;
            console.log(this.person_select_new.personal_id);
            // console.log(this.process_ordop_person.persons_old);

            if(ipo === -1){
                // agregamos a la persona
                if(this.charge_temp_new !==null && this.charge_temp_new !==''){
                    let tempper={
                        id_person:this.person_select_new.personal_id,
                        complete:`${this.person_select_new.grade} ${this.person_select_new.speciality} ${this.person_select_new.complete}`,
                        charge:this.charge_temp_new.toUpperCase(),
                        order:countReg+1,
                        is_edit:false,
                        type:'N',
                        id_unidad:this.person_select.id_unidad,
                        unidad:this.person_select.name_port
                    }
                    this.process_ordop_person.persons_old.push(tempper);
                    // this.process_ordop_person.persons_new.push(tempper);
                    this.charge_temp_new=null;
                }else{
                    toastr.info(`Para agregar a la persona seleccionada ${this.person_select_new.complete} debe indicar un cargo o Rol`, 'Alerta');
                }
            }else{
                // no agregamos dado que ya existe la persona
                toastr.warning(`La persona seleccionada ${this.person_select_new.complete} ya se encuentra en la lista`, 'Alerta');
            }
        },
        mAppendPerson(){
            // anadimos a la persona en lista de participantes de la ORDOP
            
            let ips=this.person_selecteds_ordop.findIndex(dts => dts.personal_id === this.person_select.personal_id);
            
            if(ips === -1){
                // agregamos a la persona
                if(this.charge_temp !==null && this.charge_temp !==''){
                    let tempper={
                        personal_id:this.person_select.personal_id,
                        complete:`${this.person_select.grade} ${this.person_select.speciality} ${this.person_select.complete}`,
                        charge:this.charge_temp.toUpperCase(),
                        id_unidad:this.person_select.id_unidad,
                        unidad:this.person_select.name_port
                    }
                    this.person_selecteds_ordop.push(tempper);
                    this.charge_temp=null;
                }else{
                    toastr.info(`Para agregar a la persona seleccionada ${this.person_select.complete} debe indicar un cargo o Rol`, 'Alerta');
                }
            }else{
                // no agregamos dado que ya existe la persona
                toastr.warning(`La persona seleccionada ${this.person_select.complete} ya se encuentra en la lista`, 'Alerta');
            }
        },
        mAppendPersonEdit(){
            // anadimos a la persona en lista de participantes de la ORDOP
            
            let ips=this.person_selecteds_ordop_edit.findIndex(dts => dts.personal_id === this.person_select.personal_id);
            if(ips === -1){
                // agregamos a la persona
                if(this.charge_temp !==null && this.charge_temp !==''){
                    let tempper={
                        personal_id:this.person_select.personal_id,
                        complete:`${this.person_select.grade} ${this.person_select.speciality} ${this.person_select.complete}`,
                        charge:this.charge_temp.toUpperCase(),
                        id_unidad:this.person_select.id_unidad,
                        unidad:this.person_select.name_port
                    }
                    this.person_selecteds_ordop_edit.push(tempper);
                    this.charge_temp=null;
                }else{
                    toastr.info(`Para agregar a la persona seleccionada ${this.person_select.complete} debe indicar un cargo o Rol`, 'Alerta');
                }
            }else{
                // no agregamos dado que ya existe la persona
                toastr.warning(`La persona seleccionada ${this.person_select.complete} ya se encuentra en la lista`, 'Alerta');
            }
        },
        mChangeLoadSwitch(){
            // console.log(this.value_load);
            if(this.value_load.val){
                this.value_load.detail='con Declaracion';
            }else{
                this.value_load.detail='sin Declaracion';
                this.loads_declare=[];
            }
        },
        mChangeInconvenientSwitch(){
            // console.log(this.value_load);
            if(this.value_inconvenient.val){
                this.value_inconvenient.detail='Con Inconvenientes en el Desarrollo de la Operacion';
                this.process_ordop.inconvenient=true;
            }else{
                this.value_inconvenient.detail='Sin Inconvenientes en el Desarrollo de la Operacion';
                this.inconvenient={description_problem:'S/D', description_solution:'S/D'};
                this.process_ordop.inconvenient=false;
            }
        },
        mGetTypeLoad(){
            // console.log(this.type_load_aux);
            if(this.type_load_aux.id === 0 ){
                console.log('es un numero ')
                console.log('desactivamos la cantidad de edicion')
                this.load_temp.disabled_quantity=true;                
            }else{
                console.log('activamos la edicion de la cantidad y deshabilitamos lo demas');
                this.load_temp.disabled_quantity=false;
            }
            
        },
        mClearForm(){
            this.select_ordop=false;
            // this.ordops=[];
        },
        mRellenarFormProcess(){
            
            this.process_ordop.done='Los hechos serán descritos en el Informe(Migración)';
            this.process_ordop.causes='Las causas serán descritas en el Informe(Migración)';
            this.process_ordop.consequence='Las consecuencias serán descritas en el Informe(Migración)';
            this.process_ordop.actions_taken='Las acciones tomadas serán descritas en el Informe(Migración)';
            this.process_ordop.conclusions='Las conclusiones serán descritas en el Informe(Migración)';
            
        },
        mRellenaFormInit(){
            let result_title_random='';
            let characters='ABCDEFGHIJLKMNOPQRSTUVWXYZ';
            let numbers_random='0123456789';
            result_title_random=characters.charAt(Math.floor(Math.random()*26))+''+numbers_random.charAt(Math.floor(Math.random()*10));

            this.dts_ordop.title=`Migración ${result_title_random}`;
            
            this.dts_ordop.task='La tarea será descrita en el Informe(Migración)';
            this.dts_ordop.purpose='El proposito será descrito en el Informe(Migración)';
            this.dts_ordop.osup=1;            
            this.dts_ordop.detail_organization='El detalle de la organización será descrito en el Informe(Migración)';
            this.dts_ordop.middle='El detalle de los medios será descrito en el Informe(Migración)';
        },
        async mListAllOrdops(){
            console.log(this.captain_ordop);
            if(this.captain_ordop !== 0){
                let rop=await axios.get(`getAllOrdopsClose/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`);
                // console.log(rop.data.length);
                if(rop.data.length>0){
                    this.ordops_list=rop.data;
                }else{
                    toastr.info('No existen ORDOPS pendientes', 'Atencion');
                }
            }else{
                toastr.warning('Seleccione una CC.PP.', 'Atencion');
            }
            
        },
        mCloseOrdopIndividualy(id){
            this.ordops_list=[];
            // this.mListAllOrdops();
        },
        mValidateInputsProcess(){
            if(this.captain_ordop===0){
                toastr.error('Seleccione una Unidad', 'Error');
                return false;
            }

            if(this.type_select===null ){
                toastr.error('Seleccione un tipo de operacion', 'Error');
                return false;
            }

            // validamos que no esten en cero ninguno opcion del arreglo de cargas
            let ce=0;
            if(this.type_load && this.value_load.val){
                if(this.loads_declare.length > 0){         
                    this.loads_declare.forEach((e, index)=>{                    
                        if(e.edit){
                            toastr.error(`El registro ${index+1} de la carga debe terminar de editarlo`, 'Error');    
                            ce++;
                        }                   

                        if( !(e.kilo > 0) && !(e.ton>0) && !(e.quantity>0) && !(e.liters>0) && !(e.man>0) && !(e.woman>0) && !(e.boy>0) && !(e.girl>0) ){
                            toastr.error(`El registro ${index+1} no indica la cantidad de la carga `, 'Error');    
                            ce++
                        }
                    })
                }else{
                    toastr.error(`Debe indicar minimamente 1 carga`, 'Error');
                    return false;
                }
            }

            if(ce>0){
                return false;
            }


            let daux=this.process_ordop.date_end.split('T');
            
            this.process_ordop.date_end=daux[0];
            
            if( this.process_ordop.date_end === null || !(this.process_ordop.date_end.length === 10) ){
                toastr.error('La fecha de Conclusion es incorrecta', 'Error');
                return false;
            }

            // validamos la hora
            let ah=this.time_end_aux.split('T');
            // console.log(ah[1]);
            let ah2=ah[1].split(':');
            this.process_ordop.time_end=ah2[0]+ah2[1];
            
            if( this.process_ordop.time_end === null ||!(this.process_ordop.time_end.length >= 3 ) || !(this.process_ordop.time_end.length <= 4)  || this.process_ordop.time_end >=2400 ){
                toastr.error('La Hora de Finalizacion es incorrecta', 'Error');
                return false;
            }               
                
            if(this.process_ordop.done===null || this.process_ordop.done.length < 7){
                toastr.error('Indique los hechos', 'Error');
                return false;
            }

            if(this.process_ordop.causes===null || this.process_ordop.causes.length < 7){
                toastr.error('Indique las causas', 'Error');
                return false;
            }

            if(this.process_ordop.actions_taken===null || this.process_ordop.actions_taken.length < 7){
                toastr.error('Indique las acciones tomadas', 'Error');
                return false;
            }

            if(this.process_ordop.conclusions===null || this.process_ordop.conclusions.length < 7){
                toastr.error('Indique las conclusiones', 'Error');
                return false;
            }

            if(this.process_ordop.inconvenient){
                if(this.process_ordop.description_problem===null){
                    toastr.error('Indique la descripcion del problema u inconveniente en el cumplimiento de esta actividad', 'Error');
                    return false;
                }
                if(this.process_ordop.description_solution===null){
                    toastr.error('Indique la descripcion de la solucion al problema u inconveniente en el cumplimiento de esta actividad', 'Error');
                    return false;
                }
            }
            
            if(this.process_ordop.import_dano<0 ){
                toastr.error('Daño Economico al Estado debe ser mayor o igual a 0', 'Error');
                return false;
            }
            
            return true;
        },
        async mSavePersonsAdd(){
            // console.log(this.process_ordop_person.persons_old);
            let message = {
                title: 'Añadir Personas',
                body: '¿Desea Actualizar el registro de Personas que Participan en la ORDOP?'
            };
            // validar que los datos esten completos
            let npr=new Promise((resolve, reject)=>{
                this.$dialog
                .confirm(message)
                .then(function(dialog) {
                    resolve(true);          
                })
                .catch(function() {
                    resolve(false);
                });
            });
                
            npr.then(async (msg)=>{
                    if(msg){
                        // registramos y validamos el presupuesto general en la bd
                        try {
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            let dts_new_pers={
                                id:this.process_ordop_person.id,
                                persons:JSON.stringify(this.process_ordop_person.persons_old)
                            }
                            console.log(dts_new_pers);
                            // this.dts_ordop.detail_organization=JSON.stringify(this.person_selecteds_ordop);
                            this.btn_u_newp = true;
                            this.activeModal(this.id_modal_progress);
                            let u_dts_ordop=await axios.post(`updatePersonOrdop/${this.process_ordop_person.id}?api_token=${Vue.auth.getToken()}`, qs.stringify(dts_new_pers));

                            setTimeout(()=>{        
                                console.log(u_dts_ordop);                        
                                if(u_dts_ordop.data.status){
                                    toastr.success(u_dts_ordop.data.respuesta);
                                    this.select_ordop_person=false;
                                    this.btn_u_newp=false;
                                    this.process_ordop_person.title=null,
                                    this.process_ordop_person.task=null,
                                    this.process_ordop_person.id=0,
                                    this.process_ordop_person.type_task=0,
                                    this.process_ordop_person.date_init=null,
                                    this.process_ordop_person.persons_old=[]
                                }
                                
                                this.inactiveModal(this.id_modal_progress);
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error')
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.dts_ordop);
                    }
                })
        },
        async mSaveProcessOrdop(){
            // validar los datos
            if(this.mValidateInputsProcess()){
                // enviar los datos al servidor
                let message = {
                    title: 'Proceso Orden de Operacion',
                    body: '¿Desea Registrar el resultado de la orden de operacion?'
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            this.btn_p_ordop = true;
                            this.activeModal(this.id_modal_progress);
                            this.process_ordop.load=JSON.stringify(this.loads_declare);
                            let s_pro_ordop=await axios.post(`registerOrdopProcess/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`, qs.stringify(this.process_ordop));
                            setTimeout(()=>{                                
                                if(s_pro_ordop.data.status){
                                    toastr.success(s_pro_ordop.data.respuesta);
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    this.btn_p_ordop = false;
                                    let aid=this.process_ordop.id;
                                    this.mCloseOrdop(aid);
                                    // limpiamos los registros previamente obtenemos el id
                                }
                                
                                this.inactiveModal(this.id_modal_progress);
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error O-01')
                                this.btn_p_ordop = false;
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }else{
                console.log('debe validarse los campos')
            }            
        },
        mValidateInputsUpdateProcess(){
            if(this.process_ordop_edit.id===0){
                toastr.error('Seleccione el resultado de una Operacion', 'Error');
                return false;
            }            
                
            if(this.process_ordop_edit.done===null || this.process_ordop_edit.done.length < 7){
                toastr.error('Indique los hechos', 'Error');
                return false;
            }

            if(this.process_ordop_edit.causes===null || this.process_ordop_edit.causes.length < 7){
                toastr.error('Indique las causas', 'Error');
                return false;
            }

            if(this.process_ordop_edit.actions_taken===null || this.process_ordop_edit.actions_taken.length < 7){
                toastr.error('Indique las acciones tomadas', 'Error');
                return false;
            }

            if(this.process_ordop_edit.conclusions===null || this.process_ordop_edit.conclusions.length < 7){
                toastr.error('Indique las conclusiones', 'Error');
                return false;
            }
            return true;
        },
        async mUpdateProcessOrdop(){
            // validar los datos
            if(this.mValidateInputsUpdateProcess()){
                // enviar los datos al servidor
                let message = {
                    title: 'Proceso Orden de Operacion',
                    body: '¿Desea actualizar el resultado de la orden de operacion?'
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            this.btn_u_ordop = true;
                            this.activeModal(this.id_modal_progress);
                            this.process_ordop.load=JSON.stringify(this.loads_declare);
                            let u_pro_ordop=await axios.post(`updateOrdopProcessResult?api_token=${Vue.auth.getToken()}`, qs.stringify(this.process_ordop_edit));
                            setTimeout(()=>{                                
                                if(u_pro_ordop.data.status){
                                    toastr.success(u_pro_ordop.data.respuesta);
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    this.btn_u_ordop = false;
                                    this.process_ordop_edit.id=0;
                                    this.process_ordop_edit.type_task=0;
                                    this.process_ordop_edit.done='';
                                    this.process_ordop_edit.causes='';
                                    this.process_ordop_edit.consequence='';
                                    this.process_ordop_edit.actions_taken='';
                                    this.process_ordop_edit.conclusions='';
                                    // let aid=this.process_ordop.id;
                                    // this.mCloseOrdop(aid);
                                    // limpiamos los registros previamente obtenemos el id
                                }
                                
                                this.inactiveModal(this.id_modal_progress);
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error O-01')
                                this.btn_p_ordop = false;
                                this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }else{
                console.log('debe validarse los campos')
            }            
        },
        async mCloseOrdop(id){
            // console.log(`llegando a cerrar el ORDOP con id ${id}`);
            let message = {
                    title: 'Cerrar la Orden de Operacion',
                    body: '¿Desea Cerrar la orden de Operacion?'
                }
                let aid=id;
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                this.select_ordop=false;
                this.mResetFormProcesOrdop();
                
                npr.then(async (msg)=>{
                    if(msg){
                        this.mCloseOrdopIndividualy();
                        // registramos el proceso de la ordop
                        try {
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            // console.log(`cerramos el ordop con id ${id}`);
                            this.activeModal(this.id_modal_progress);
                            let c_ordop=await axios.post(`inactiveOrdop/${aid}?api_token=${Vue.auth.getToken()}`);
                            console.log(c_ordop);
                            setTimeout(()=>{                                
                                if(c_ordop.data.status){
                                    toastr.success(c_ordop.data.respuesta, 'Exito');
                                    // preguntamos si se cerrara el ordop para que no aparezca
                                    // limpiamos los campos en caso de no haberse limpiado
                                }else{
                                    toastr.warning(c_ordop.data.respuesta, 'Error');
                                }                                
                                this.inactiveModal(this.id_modal_progress);
                            },1000)
                            this.mCallOrdopsVigent();
                        }catch(err){
                            console.log('no se va a cerrar el ordop');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error O-02')
                                // this.inactiveModal(this.id_modal_progress);
                            }, 3000)
                        }
                    }else{
                        console.log('No se cerro la ordop')
                        toastr.warning('El ORDOP aun continua vigente', 'Atencion!!')
                        // console.log(this.s_pro_ordop);
                    }
                })
        },
        // reset form ordop
        mResetLoad(){
            this.loads_declare=[];
        },
        mResetFormProcesOrdop(){
                this.mResetLoad();
                this.type_select=null;
                this.time_end_aux=null;
                this.process_ordop.id=0;
                this.process_ordop.title=null;
                this.process_ordop.task=null;
                this.process_ordop.type_task=0;
                this.process_ordop.date_init=null;
                this.process_ordop.date_end=null;
                this.process_ordop.time_end=null;
                this.process_ordop.done=null;
                this.process_ordop.causes=null;
                this.process_ordop.consequence=null;
                this.process_ordop.actions_taken=null;
                this.process_ordop.conclusions=null;
                this.process_ordop.load=[];
                this.process_ordop.inconvenient=false;
                this.inconvenient=false;
                this.process_ordop.description_problem=null;
                this.process_ordop.description_solution=null;
                this.process_ordop.import_dano=0;
                this.query_ordop=null;
        },
        mSelectLoadOrdop(data){
            // console.log(data);
            // load_ordop
            // loads_type
            
            let aux_load_process={                    
                id_load:data.id,
                id_load_specify:data.id_l,
                detail_load:data.carga_detail,
                kilo:0,
                ton:0,
                liters:0,
                woman:0,
                man:0,
                boy:0,
                girl:0,
                quantity:0,
                unit:data.unit_measurement,
                edit:false,
                disabled_quantity:true,
                type_aux_load:0,
                type_aux_load_des:'NINGUNO',
                description_load:null,
            }
            // verificar previamente que no exista la categoria ya registrada

            let vrc=false;
            if(this.loads_declare.length > 0){
                let aux_loads=this.loads_declare;
                
                aux_loads.forEach(e=>{
                    if(e.id_load===data.id && e.id_load_specify===data.id_l){
                        vrc=true;
                    }
                });

                // si es true 
                if( !vrc ){
                    // anadimos la carga al json
                    this.loads_declare.push(aux_load_process);
                    // luego verificar el tipo de unidad de medida para la carga para el formulario
                    // console.log(this.loads_declare);
                    // para dibujar en el formulario las distintas cargas con sus respectivas medidas

                }else{
                    toastr.warning('No se puede añadir la misma carga dos veces', 'Advertencia');
                }
            }else{
                this.loads_declare.push(aux_load_process);
                
            }
            // anadir a la carga declarada
            // this.loads_type=[];
            // this.select_load=data.carga_detail;
            // this.process_ordop.id_load=data.id;
            // this.process_ordop.detail_load=data.carga_detail;
            // this.viewForm(data.unit_measurement);
            // this.is_select_load=true;
        },
        mEditValues(i){
            // pasamos del indice sus valores al temporal de datos
            // this.type_load_aux.id=this.loads_declare[i].type_aux_load;
            if(this.load_temp.active){
                // si esta activo colocamos todo en false de las cargas procedemos a vaciar del nuevo registro
                this.loads_declare.forEach(e =>{
                    if(e.edit){
                        e.edit=false;
                    }
                });                
                
                // this.type_load_aux.detail=this.loads_declare[i].type_aux_load_des;
                
                this.load_temp.kilo=this.loads_declare[i].kilo;
                this.load_temp.ton=this.loads_declare[i].ton;
                this.load_temp.quantity=this.loads_declare[i].quantity;
                this.load_temp.liters=this.loads_declare[i].liters;
                this.load_temp.man=this.loads_declare[i].man;
                this.load_temp.woman=this.loads_declare[i].woman;
                this.load_temp.boy=this.loads_declare[i].boy;
                this.load_temp.girl=this.loads_declare[i].girl;
                this.load_temp.disabled_quantity=this.loads_declare[i].disabled_quantity;
                this.load_temp.type_aux_load=this.loads_declare[i].type_aux_load;
                this.load_temp.type_aux_load_des=this.loads_declare[i].type_aux_load_des;
                this.load_temp.description_load=this.loads_declare[i].description_load;
                this.loads_declare[i].edit=true;
                this.load_temp.active=true;
            }else{
                // this.type_load_aux.id=this.loads_declare[i].type_aux_load;
                // this.type_load_aux.detail=this.loads_declare[i].type_aux_load_des;

                // simplemente vaciamos los datos al temp
                this.load_temp.kilo=this.loads_declare[i].kilo;
                this.load_temp.ton=this.loads_declare[i].ton;
                this.load_temp.quantity=this.loads_declare[i].quantity;
                this.load_temp.liters=this.loads_declare[i].liters;
                this.load_temp.man=this.loads_declare[i].man;
                this.load_temp.woman=this.loads_declare[i].woman;
                this.load_temp.boy=this.loads_declare[i].boy;
                this.load_temp.girl=this.loads_declare[i].girl;
                this.load_temp.disabled_quantity=this.loads_declare[i].disabled_quantity;
                this.load_temp.type_aux_load=this.loads_declare[i].type_aux_load;
                this.load_temp.type_aux_load_des=this.loads_declare[i].type_aux_load_des;
                this.load_temp.description_load=this.loads_declare[i].description_load;
                this.loads_declare[i].edit=true;
                this.load_temp.active=true;
            }
            // this.type_load_aux.id=this.load_temp.type_aux_load;
        },
        mSaveValues(i){
            
            // guardamos el valor del tipo de carga
            // console.log(this.loads_declare);
            // console.log(this.type_load_aux.id);
            // console.log(this.loads_declare[i]);
            this.type_load_aux.id = this.loads_declare[i].unit==='P'? 0:this.type_load_aux.id;
            if(this.type_load_aux.id>-1 ){
                
                if(this.load_temp.kilo>0 || this.load_temp.ton>0 || this.load_temp.quantity>0 || this.load_temp.liters>0 || this.load_temp.man>0 || this.load_temp.woman>0 || this.load_temp.boy>0 || this.load_temp.girl>0){
                    // console.log(this.type_load_aux.id);
                    this.load_temp.type_aux_load=this.type_load_aux.id;
                    this.load_temp.type_aux_load_des=this.type_load_aux.id>0 ? this.type_load_aux.detail:'NINGUNO';                
                    
                    this.type_load_aux={};
                    
                    // guardamos del temporal al array
                    this.loads_declare[i].kilo=this.load_temp.type_aux_load === 0 ? this.load_temp.kilo:0;
                    this.loads_declare[i].ton=this.load_temp.type_aux_load === 0 ? this.load_temp.ton:0;
                    this.loads_declare[i].quantity=this.load_temp.type_aux_load > 0 ? this.load_temp.quantity:0;
                    this.loads_declare[i].liters=this.load_temp.type_aux_load===0 ? this.load_temp.liters:0;
                    this.loads_declare[i].man= this.load_temp.type_aux_load===0 ? this.load_temp.man:0;
                    this.loads_declare[i].woman= this.load_temp.type_aux_load===0 ? this.load_temp.woman:0;
                    this.loads_declare[i].boy=this.load_temp.type_aux_load ===0 ? this.load_temp.boy:0;
                    this.loads_declare[i].girl= this.load_temp.type_aux_load ===0 ? this.load_temp.girl:0;
                    
                    this.loads_declare[i].disabled_quantity=this.load_temp.disabled_quantity;
                    this.loads_declare[i].type_aux_load=this.load_temp.type_aux_load;
                    this.loads_declare[i].type_aux_load_des=this.load_temp.type_aux_load_des;
                    this.loads_declare[i].description_load=this.load_temp.description_load;

                    this.loads_declare[i].edit=false;
                    this.load_temp.active=false;
                }else{
                    toastr.warning(`Los valores de la carga en la fila ${i+1} debe ser mayor a 0`, 'Advertencia');    
                }
            }else{
                toastr.warning(`Seleccione un tipo de carga en la fila ${i+1}`, 'Advertencia');
            }
            // vaciamos del temp a su posicion original
        },
        mQuitLoad(i){
            // eliminamos el registro
            this.loads_declare.splice(i, 1);
        },
        mCancelEditLoad(i){
            // cancelamos la edicion
            this.loads_declare[i].edit=false;
            this.load_temp.active=false;
        },
        mSelectType(){
            // console.log(this.type_select)
            this.process_ordop.type_task=this.type_select.id;
            // console.log(this.type_select);
            if(this.type_select.item === 0){
                // reiniciamos todo a cero sin carga
                this.type_load=false;
                this.mResetLoad();
            }else{
                // habilitamos el tipo de carga
                this.type_load=true;
            }
        },
        mSelectOrdop(){  
            // console.log(data)
            let data = this.ordop_select_process          
            let fi=this.mDateMilitary(data.fecha_inicio, '-', data.hora_inicio);
            this.date_init_aux=fi;
            this.process_ordop.id=data.id;
            this.process_ordop.title=`${data.titulo_ordop} (${data.tipo_ordop})`;
            this.process_ordop.task=data.tarea;
            this.process_ordop.type_task=0;
            this.process_ordop.date_init=data.fecha_inicio;
            this.process_ordop.date_end=null;
            this.process_ordop.done=null;
            this.process_ordop.causes=null;
            this.process_ordop.actions_taken=null;
            this.process_ordop.conclusions=null;
            this.process_ordop.load=[];
            
            this.select_ordop=true;
        },
        mVerifyCampEditPersonOld(){
            // this.process_ordop_person.persons_old.forEach(dt)
            console.log(this.process_ordop_person.persons_old);
            // this.process_ordop_person.persons_old.forEach( (dtb,key)=>{
            //     if( dtb.is_edit ){
            //          this.this.process_ordop_person.persons_old[key].is_edit=false;
            //          this.persons_old_temp={};
            //     }
            // });
            for(let key in this.process_ordop_person.persons_old){
                if( this.process_ordop_person.persons_old[key].is_edit ){
                     this.process_ordop_person.persons_old[key].is_edit=false;
                     this.persons_old_temp={};
                }
            }
        },
        mEditPersonOld(index){
            // crear un temporal de edicion al momento de editar el temporal se debe llenar con los datos anteriores si se acepta la edicion se guarda y reemplaza, NO se mantiene el valor y se elimina el temporal, crear un id o key en cada registro dado que el codigo otros reeemplazara donde sea.
            // verificamos que no haya otro campo en edicion
            this.mVerifyCampEditPersonOld();            
            this.persons_old_temp={
                complete:this.process_ordop_person.persons_old[index].complete,
                charge:this.process_ordop_person.persons_old[index].charge,
                id_person:this.process_ordop_person.persons_old[index].id_person,
                order:this.process_ordop_person.persons_old[index].order,
                indice:index
            }
            this.process_ordop_person.persons_old[index].is_edit=true;            
            
        },
        mOrderListNews(){
            this.process_ordop_person.persons_old.sort( (a, b) => {
                if(a.order < b.order) {
                    return -1;
                }
                if(a.order > b.order) {
                    return 1;
                }
                if (a.complete.toLowerCase() < b.complete.toLowerCase()) {
                    return -1;
                }
                if (a.complete.toLowerCase() > b.complete.toLowerCase()) {
                    return 1;
                }
                return 0;
            });
            console.log(this.process_ordop_person.persons_old);
        },
        mSavePersonOld(index){            
            // console.log(`terminando de editar el item ${index}`);
            if(this.persons_old_temp.order >0){

                if(this.persons_old_temp.indice===index){
                    this.process_ordop_person.persons_old[index].order=this.persons_old_temp.order;
                    this.process_ordop_person.persons_old[index].is_edit=false;
                    this.persons_old_temp={};
                    this.mOrderListNews();
                }else{
                    toastr.warning(`Verifique la sancion editada en la fila ${index+1}`);
                }
            }else{
                toastr.warning("Indique un valor mayor a 0 para su impresion", "Orden de Impresion");
            }
        },
        mCancelEditPersonOld(index){
            this.process_ordop_person.persons_old[index].is_edit=false;
        },
        async mSelectOrdopPerson(){
            this.process_ordop_person.persons_old=[];
            let data = this.ordop_select_persons     
            console.log(data);     
            let fi=this.mDateMilitary(data.fecha_inicio, '-', data.hora_inicio);
            this.date_init_aux_person=fi;
            // aqui llamar los datos de las personas registradas
            let persons=await axios.get(`getOrdopPersons/${data.id}?api_token=${Vue.auth.getToken()}`);
            console.log(persons);
            persons.data.forEach(el=>{
                let aux_per_old={
                    complete:el.complete,
                    charge:el.charge,
                    id_person:el.id_person,
                    order:el.order,
                    is_edit:false,
                    type:'O'
                };
                this.process_ordop_person.persons_old.push(aux_per_old);
            });
            // this.process_ordop_person.persons_old=persons.data;
            this.process_ordop_person.id=data.id;
            this.process_ordop_person.title=`${data.titulo_ordop} (${data.tipo_ordop})`;
            this.process_ordop_person.task=data.tarea;
            this.process_ordop_person.type_task=0;
            this.process_ordop_person.date_init=data.fecha_inicio;
            this.process_ordop_person.persons_new=[];
            
            
            this.select_ordop_person=true;       
        },
        async mSelectOrdopDocument(){
            // aqui seleccionamos la ordop para incluir a mas personas
            let data = this.ordop_document     
            console.log(data);     
            let fi=this.mDateMilitary(data.fecha_inicio, '-', data.hora_inicio);
            this.date_init_aux_person=fi;
            // aqui llamar los datos de las personas registradas
            this.ordop_document_select=data;
        },
        mDateMilitary(d, c='/', h){
            let ft=d.split(c);
            let nfm;
            if(c==='/'){
                nfm=`${ft[0]}${h}/${ft[1]}/${ft[2]}`;
            }else{
                nfm=`${ft[2]}${h}/${ft[1]}/${ft[0]}`;
            }
            return nfm;
        },
        verifyCategory(){
            this.captain_ordop=this.cDtsUser.role===4 ? this.cDtsUser.portId : 0;
            this.captain_process_ordop=this.captain_ordop;
            // console.log(`la capitanias es ${this.captain}`);
        },
        async mCallOrdopsSuperior(){
            try {
                this.animate_master=true;
                this.ordop_master=[];
                setTimeout(async () => {
                    let ordsup=await axios.get(`listOrdopsMasterOperador?api_token=${Vue.auth.getToken()}`);
                    if(ordsup.data.length>0){
                        this.ordop_master=ordsup.data;
                    }    
                    this.animate_master=false;
                }, 1000);    
            } catch (error) {
                console.log(error);
                this.animate_master=false;
                
            }
            
            
        },
        async callCaptains(){
            let ya=new Date();

            let year_select=ya.getFullYear();
            const init=2018;
            this.years=[];
            for(let i=init; i<= year_select; i++){
                let ai={c:i};
                this.years.push(ai);
            }
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            let od=await axios.get(`globals/ordop?api_token=${Vue.auth.getToken()}`);
            let odi=await axios.get(`globals/ordopinit?api_token=${Vue.auth.getToken()}`);
            let load_liquid= await axios.get(`globals/liquid?api_token=${Vue.auth.getToken()}`);
            let load_solid= await axios.get(`globals/solid?api_token=${Vue.auth.getToken()}`);
            let to=await axios.get(`globals/tipoordop?api_token=${Vue.auth.getToken()}`)
            
            
            
            if(this.cDtsUser.roleAssign === 'OPERADOR'){
                // llamamos al personal de su capitania
                let callPers= await axios.get(`personalCaptains/${this.cDtsUser.portId}?api_token=${Vue.auth.getToken()}`);
                console.log(callPers.data);
                this.persons_captain=callPers.data;
                
            }

            // console.log(od);
            this.types_ordop=od.data;
            this.types_ordop_init=odi.data;
            this.tipos_ordop=to.data;
            
            let noOption={
                id:0,
                detail:'NINGUNO'
            };

            this.type_load_liquid=[];
            this.type_load_solid=[];
            this.type_load_liquid.push(noOption);
            this.type_load_solid.push(noOption);

            load_liquid.data.forEach(v=>{
                let auxCharge={
                    id:v.id,
                    detail:v.detail
                }
                this.type_load_liquid.push(auxCharge);
            })

            load_solid.data.forEach(v=>{
                let auxCharge={
                    id:v.id,
                    detail:v.detail
                }
                this.type_load_solid.push(auxCharge);
            })
            // console.log(cp);
            this.ports=cp.data;
            let lRiver=await axios.get(`getListLake?api_token=${Vue.auth.getToken()}`);
            // console.log(listRiver);
            this.list_lake=lRiver.data;
        },
        mValidateOrdop(){
            
            if(this.ordop_master_select.id===-1){
                toastr.warning(`Seleccione una opcion de las Ordops Emanadas por el Comando de la Armada`);
                return false;
            }
            
            if(this.captain_ordop===0 && this.cDtsUser.role === 4){
                toastr.error('Seleccione una Unidad', 'Error');
                return false;
            }

            if(  !(this.dts_ordop.title !== null)  ){
                toastr.error('Indique el Titulo de la ORDOP', 'Error');
                return false;
            }

            if(  this.dts_ordop.type === 0  ){
                toastr.error('Seleccione el tipo de ORDOP', 'Error');
                return false;
            }
            
            if(  this.dts_ordop.tipo_init === 0  ){
                toastr.error('Seleccione una opcion entre ESPECIFICA, CONJUNTA O COMBINADA', 'Error');
                return false;
            }

            let adi=this.dts_ordop.date_init.split('T');
            this.dts_ordop.date_init=adi[0];

            if( this.dts_ordop.date_init === null || !(this.dts_ordop.date_init.length === 10) ){
                toastr.error('La fecha de Inicio es incorrecta', 'Error');
                return false;
            }
            
            try {
                let ah=this.time_init_aux.split('T');
                let ah2=ah[1].split(':');
                this.dts_ordop.time_init=ah2[0]+ah2[1];
                // console.log(this.dts_ordop.time_init);
                if( this.dts_ordop.time_init === null ||!(this.dts_ordop.time_init.length >= 3 ) || !(this.dts_ordop.time_init.length <= 4)  || this.dts_ordop.time_init >=2400 ){
                    toastr.error('La Hora de Inicio es incorrecta', 'Error');
                    return false;
                }    
            } catch (error) {
                console.log(error);
                toastr.error('La Hora de Inicio es incorrecta', 'Error');
                return false;
            }
            

            if ( this.dts_ordop.task === null || !(this.dts_ordop.task.length >= 5)){
                toastr.error('Describa la tarea mas especifico', 'Error');
                return false;
            }
            // if ( this.dts_ordop.purpose === null || !(this.dts_ordop.purpose.length >= 5)){
            //     toastr.error('El proposito debe ser mas especifico', 'Error');
            //     return false;
            // }           
            

            // verifica si se indico la fecha de conclusion
            // if(this.dts_ordop.date_end !== null){
            //     if( this.dts_ordop.date_end === null || !(this.dts_ordop.date_end.length === 10) ){
            //         toastr.error('La fecha de Conclusion es incorrecta', 'Error');
            //         return false;
            //     }   
            // }
            
            // // verifica si se indico la hora de conclusion
            // if(this.dts_ordop.time_end !== 0){
            //     if( this.dts_ordop.time_end === null ||!(this.dts_ordop.time_end.length >= 3 ) || !(this.dts_ordop.time_end.length <= 4)  || this.dts_ordop.time_end >=2400 ){
            //         toastr.error('La Hora de Finalizacion es incorrecta', 'Error');
            //         return false;
            //     }   
            // }
            
            if(this.person_selecteds_ordop.length <= 0){
                toastr.error('Indique la Organizacion de los RRHH en la ORDOP', 'Error');
                return false;
            }

            // if( this.dts_ordop.detail_organization === null || !(this.dts_ordop.detail_organization.length > 5) ){
            //     toastr.error('Indique la Organizacion de los RRHH en la ORDOP', 'Error');
            //     return false;
            // }

            // if( this.dts_ordop.middle === null || !(this.dts_ordop.middle.length > 5) ){
            //     toastr.error('Indique los Medios empleados en la ORDOP', 'Error');
            //     return false;
            // }

            // if(  !(this.dts_ordop.execution.length > 5) ){
            //     toastr.error('Indique la descripcion de la Ejecución de la ORDOP', 'Error');
            //     return false;
            // }

            // if(  !(this.dts_ordop.coordinacion.length > 5) ){
            //     toastr.error('Indique las Instrucciones de Coordinacion de la ORDOP', 'Error');
            //     return false;
            // }


            // if(  !(this.dts_ordop.comunication.length > 5) ){
            //     toastr.error('Indique las Comunicaciones empleadas en la ORDOP', 'Error');
            //     return false;
            // }

            return true;
        },
        async mRellenaDtsAux(){
            let recoveryInfo=await axios.get(`getOrdopAux/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`);
            // console.log(recoveryInfo);
            this.dts_ordop.comunication=recoveryInfo.data[0].comunicaciones;
            this.dts_ordop.middle=recoveryInfo.data[0].medios;
            this.dts_ordop.coordinacion=recoveryInfo.data[0].coordinacion;
            this.dts_ordop.execution=recoveryInfo.data[0].ejecucion;
        },
        async saveOrdop(){
            let contribuyente=this.ordop_master_select.id!==0 ? `Contribuyente:<b>SI</b>`:`Contribuyente:<b>NO</b>`;
            let titulo_contribuyente=this.ordop_master_select.id!==0 ? `Ordop Armada:<b>${this.ordop_master_select.titulo_superior}</b>`:`Ordop Armada:<b>NO REGISTRA</b>`;
            let advertencia=this.ordop_master_select.id!==0 ? `<b>Nota:</b> Si Usted esta registrando una Operacion que no corresponda a una Orden Contribuyente y esta sera verificada, sera pasible a la sanción correspondiente de acuerdo a Reglamento`:``;
            let mensaje=`¿Desea registrar la Orden de Operacion ${this.dts_ordop.title}? <br> ${contribuyente} <br> ${titulo_contribuyente} <br> ${advertencia}`
            let message = {
                title: 'Orden de Operacion',
                body: mensaje
            };
            // validar que los datos esten completos

            if(this.mValidateOrdop()){
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos y validamos el presupuesto general en la bd
                        try {
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            console.log(`se esta registrando la ordop superior`);
                            console.log(this.ordop_master_select);
                            this.dts_ordop.id_ordop_master=this.ordop_master_select.id;
                            this.dts_ordop.titulo_ordop_master=this.ordop_master_select.id!==0 ? this.ordop_master_select.titulo_superior:'';
                            this.dts_ordop.id_division=this.ordop_master_select.id!==0? this.ordop_master_select.division:0;
                            this.dts_ordop.division_origen=this.ordop_master_select.id!==0 ? this.ordop_master_select.descripcion_division:'';
                            this.dts_ordop.contribuyente=this.ordop_master_select.id!==0 ? 'S':'N';
                            
                            this.dts_ordop.detail_organization=JSON.stringify(this.person_selecteds_ordop);
                            this.dts_ordop.lakes=JSON.stringify(this.lake_select);
                            this.btn_r_ordop = true;
                            this.activeModal(this.id_modal_progress);
                            let s_dts_ordop=await axios.post(`registerOrdopInit/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`, qs.stringify(this.dts_ordop));

                            setTimeout(()=>{                                
                                if(s_dts_ordop.data.status){
                                    toastr.success(s_dts_ordop.data.respuesta);
                                    this.dts_ordop.title=null;
                                    this.dts_ordop.type=0;
                                    this.dts_ordop.task=null;
                                    this.dts_ordop.purpose=null;
                                    this.dts_ordop.date_init=null;
                                    this.dts_ordop.date_end=null;
                                    this.dts_ordop.time_init=0;
                                    this.dts_ordop.time_end=0;
                                    this.dts_ordop.osup=0;
                                    this.dts_ordop.osub=0;
                                    this.dts_ordop.so=0;
                                    this.dts_ordop.sgto=0;
                                    this.dts_ordop.mar=0;
                                    this.dts_ordop.vehicle=0;
                                    this.dts_ordop.ship=0;
                                    this.dts_ordop.detail_organization=null;
                                    this.dts_ordop.lakes=[];
                                    this.dts_ordop.middle=null;
                                    this.btn_r_ordop = false;
                                    this.time_init_aux=null;
                                    this.person_selecteds_ordop=[];
                                    this.lake_select=[];
                                    this.dts_ordop.coordinacion='';
                                    this.dts_ordop.comunication='';
                                    this.dts_ordop.execution='';
                                    this.dts_ordop.init=false;
                                }else{
                                    toastr.warning(s_dts_ordop.data.respuesta);
                                    this.btn_r_ordop = false;    
                                }                               
                                this.inactiveModal(this.id_modal_progress);
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error')
                                this.inactiveModal(this.id_modal_progress);
                                this.btn_r_ordop = false;
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.dts_ordop);
                    }
                })
            }else{
                console.log('debe validarse los campos')
            }
        },
        mValidateOrdopEdit(){
            
            if(this.captain_ordop===0 && this.cDtsUser.role === 4){
                toastr.error('Seleccione una Unidad', 'Error');
                return false;
            }

            if(  !(this.dts_ordop_edit.title !== null)  ){
                toastr.error('Indique el Titulo de la ORDOP', 'Error');
                return false;
            }

            if(  this.dts_ordop_edit.type === 0  ){
                toastr.error('Seleccione el tipo de ORDOP', 'Error');
                return false;
            }
            
            if(  this.dts_ordop_edit.tipo_init === 0  ){
                toastr.error('Seleccione el tipo de Operacion COMBINADA, CONJUNTA o ESPECIFICA', 'Error');
                return false;
            }
            
            if ( this.dts_ordop_edit.task === null || !(this.dts_ordop_edit.task.length >= 5)){
                toastr.error('Describa la tarea mas especifico', 'Error');
                return false;
            }
            
            if ( this.dts_ordop_edit.purpose === null || !(this.dts_ordop_edit.purpose.length >= 5)){
                toastr.error('El proposito debe ser mas especifico', 'Error');
                return false;
            }

            let adi=this.dts_ordop_edit.date_init.split('T');
            this.dts_ordop_edit.date_init=adi[0];

            if( this.dts_ordop_edit.date_init === null || !(this.dts_ordop_edit.date_init.length === 10) ){
                toastr.error('La fecha de Inicio es incorrecta', 'Error');
                return false;
            }
            
            try {
                let ah=this.time_init_aux_edit.split('T');
                let ah2=ah[1].split(':');
                this.dts_ordop_edit.time_init=ah2[0]+ah2[1];
                // console.log(this.dts_ordop_edit.time_init);
                if( this.dts_ordop_edit.time_init === null ||!(this.dts_ordop_edit.time_init.length >= 3 ) || !(this.dts_ordop_edit.time_init.length <= 4)  || this.dts_ordop_edit.time_init >=2400 ){
                    toastr.error('La Hora de Inicio es incorrecta', 'Error');
                    return false;
                }    
            } catch (error) {
                console.log(error)
                toastr.error('La Hora de Inicio es incorrecta', 'Error');
                return false;
            }
            
            

            // verifica si se indico la fecha de conclusion
            if(this.dts_ordop_edit.date_end !== null){
                if( this.dts_ordop_edit.date_end === null || !(this.dts_ordop_edit.date_end.length === 10) ){
                    toastr.error('La fecha de Conclusion es incorrecta', 'Error');
                    return false;
                }   
            }
            
            // verifica si se indico la hora de conclusion
            if(this.dts_ordop_edit.time_end !== 0){
                if( this.dts_ordop_edit.time_end === null ||!(this.dts_ordop_edit.time_end.length >= 3 ) || !(this.dts_ordop_edit.time_end.length <= 4)  || this.dts_ordop_edit.time_end >=2400 ){
                    toastr.error('La Hora de Finalizacion es incorrecta', 'Error');
                    return false;
                }   
            }
            
            if(this.person_selecteds_ordop_edit.length <= 0){
                toastr.error('Indique la Organizacion de los RRHH en la ORDOP', 'Error');
                return false;
            }

            // if( this.dts_ordop_edit.detail_organization === null || !(this.dts_ordop_edit.detail_organization.length > 5) ){
            //     toastr.error('Indique la Organizacion de los RRHH en la ORDOP', 'Error');
            //     return false;
            // }

            if( this.dts_ordop_edit.middle === null || !(this.dts_ordop_edit.middle.length > 5) ){
                toastr.error('Indique los Medios empleados en la ORDOP', 'Error');
                return false;
            }

            if(  !(this.dts_ordop_edit.execution.length > 5) ){
                toastr.error('Indique la descripcion de la Ejecución de la ORDOP', 'Error');
                return false;
            }

            if(  !(this.dts_ordop_edit.coordinacion.length > 5) ){
                toastr.error('Indique las Instrucciones de Coordinacion de la ORDOP', 'Error');
                return false;
            }


            if(  !(this.dts_ordop_edit.comunication.length > 5) ){
                toastr.error('Indique las Comunicaciones empleadas en la ORDOP', 'Error');
                return false;
            }

            return true;
        },
        async saveOrdopEdit(){
            let message = {
                title: 'Orden de Operacion',
                body: '¿Desea Actualizar la orden de operacion?'
            };
            // validar que los datos esten completos

            if(this.mValidateOrdopEdit()){
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos y validamos el presupuesto general en la bd
                        try {
                            // let btn_send=document.getElementById(this.btn_r_ordop);
                            this.dts_ordop_edit.detail_organization=JSON.stringify(this.person_selecteds_ordop_edit);
                            this.dts_ordop_edit.lakes=JSON.stringify(this.lake_select_edit);
                            this.btn_r_ordop_edit = true;
                            this.activeModal(this.id_modal_progress);
                            let u_dts_ordop=await axios.post(`updateOrdopInit/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`, qs.stringify(this.dts_ordop_edit));

                            setTimeout(()=>{                                
                                if(u_dts_ordop.data.status){
                                    toastr.success(u_dts_ordop.data.respuesta);
                                    this.dts_ordop_edit.id_ordop=0;
                                    this.dts_ordop_edit.title=null;
                                    this.dts_ordop_edit.type=0;
                                    this.dts_ordop_edit.tipo_init=0;
                                    this.dts_ordop_edit.task=null;
                                    this.dts_ordop_edit.purpose=null;
                                    this.dts_ordop_edit.date_init=null;
                                    this.dts_ordop_edit.date_end=null;
                                    this.dts_ordop_edit.time_init=0;
                                    this.dts_ordop_edit.time_end=0;
                                    this.dts_ordop_edit.osup=0;
                                    this.dts_ordop_edit.osub=0;
                                    this.dts_ordop_edit.so=0;
                                    this.dts_ordop_edit.sgto=0;
                                    this.dts_ordop_edit.mar=0;
                                    this.dts_ordop_edit.vehicle=0;
                                    this.dts_ordop_edit.ship=0;
                                    this.dts_ordop_edit.detail_organization=null;
                                    this.dts_ordop_edit.lakes=[];
                                    this.dts_ordop_edit.middle=null;
                                    this.btn_r_ordop_edit = false;
                                    this.time_init_aux_edit=null;
                                    this.person_selecteds_ordop_edit=[];
                                    this.lake_select_edit=[];
                                    this.dts_ordop_edit.coordinacion='';
                                    this.dts_ordop_edit.comunication='';
                                    this.dts_ordop_edit.execution='';
                                }                                
                                this.inactiveModal(this.id_modal_progress);
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error')
                                this.inactiveModal(this.id_modal_progress);
                                this.btn_r_ordop = false;
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.dts_ordop);
                    }
                })
            }else{
                console.log('debe validarse los campos')
            }
        },
        mCalcToneladaKilo(){
            this.load_temp.kilo=this.load_temp.ton*1000;
        },
        mCalcKiloTonelada(){
            this.load_temp.ton=this.load_temp.kilo/1000;
        },
        activeModal(e){
            $(`#${e}`).modal('show');
        },
        inactiveModal(e){
            $(`#${e}`).modal('hide');
        },
        async mCallOrdopsVigent(){
            this.ordops=[];
            let res_ordops=await axios.get(`getOrdopsList/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`);
            if(res_ordops.data.length > 0){
                this.ordops=res_ordops.data;
            }else{
                toastr.info(`No Existe ORDOPS registradas`, `Advretencia`);
                this.ordops=[];
            }
        },
        async mCallOrdopsVigentResult(){
            this.ordops=[];
            let res_ordops=await axios.get(`getOrdopsList/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`);
            if(res_ordops.data.length > 0){
                this.ordops=res_ordops.data;
            }else{
                toastr.info(`No Existe ORDOPS registradas`, `Advretencia`);
                this.ordops=[];
            }
        },
        async mCallOrdopsDocuments(){
            
            this.ordops_persons=[];
            let res_ordops=await axios.get(`getOrdopsListAll/${this.captain_ordop}/${this.gestion}?api_token=${Vue.auth.getToken()}`);
            if(res_ordops.data.length > 0){
                this.ordops_persons=res_ordops.data;
            }else{
                toastr.info(`No Existe ORDOPS registradas`, `Advretencia`);
                this.ordops_persons=[];
            }
        },
        async mCallOrdopsVigentPersons(){
            this.ordops_persons=[];
            let res_ordops=await axios.get(`getOrdopsList/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`);
            if(res_ordops.data.length > 0){
                this.ordops_persons=res_ordops.data;
            }else{
                toastr.info(`No Existe ORDOPS registradas`, `Advretencia`);
                this.ordops_persons=[];
            }
        },
        async mCallOrdopsVigentExecution(){
            this.ordops_execution=[];
            let res_ordops=await axios.get(`getOrdopsList/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`);
            if(res_ordops.data.length > 0){
                res_ordops.data.forEach(dat=>{
                    let aux_vig=dat.ejecucion_vigente === null ? 'N':dat.ejecucion_vigente;
                    let est_aux=aux_vig==='S' ? 'ORDOP Actualmente en Ejecución':'La ORDOP NO esta en Ejecución';
                    let aux_ordop={
                        id:dat.id,
                        titulo_ordop:dat.titulo_ordop,
                        estado:est_aux,
                        ejecucion_vigente:aux_vig
                    }
                    this.ordops_execution.push(aux_ordop);
                })
            }else{
                toastr.info(`No Existe ORDOPS registradas`, `Advretencia`);
                this.ordops_execution=[];
            }
        },
        async mCallOrdopsVigentEdit(){

            let ordop_edit = await axios.get(`getOrdopEdit/${this.ordop_select_edit.id}?api_token=${Vue.auth.getToken()}`);
            console.log(ordop_edit);
            // this.dts_ordop_edit=ordop_edit.data;
            if(ordop_edit.data.id_ordop>0){
                this.dts_ordop_edit.id_ordop=ordop_edit.data.id_ordop;
                this.dts_ordop_edit.title=ordop_edit.data.titulo_ordop;
                this.dts_ordop_edit.situation=ordop_edit.data.situacion;
                this.dts_ordop_edit.type=ordop_edit.data.id_tipo_ordop;
                this.dts_ordop_edit.tipo_init=ordop_edit.data.tipo_ordop;
                this.dts_ordop_edit.task=ordop_edit.data.tarea;
                this.dts_ordop_edit.purpose=ordop_edit.data.proposito;
                this.dts_ordop_edit.date_init=ordop_edit.data.fecha_inicio;
                this.dts_ordop_edit.date_end=null;
                this.dts_ordop_edit.time_init=ordop_edit.data.hora_inicio;
                this.dts_ordop_edit.time_end=0;
                this.dts_ordop_edit.osup=ordop_edit.data.superiores;
                this.dts_ordop_edit.osub=ordop_edit.data.subalternos;
                this.dts_ordop_edit.so=ordop_edit.data.suboficiales;
                this.dts_ordop_edit.sgto=ordop_edit.data.sargentos;
                this.dts_ordop_edit.mar=ordop_edit.data.marinos;
                this.dts_ordop_edit.vehicle=ordop_edit.data.u_terrestres;
                this.dts_ordop_edit.ship=ordop_edit.data.u_acuaticas;
                this.dts_ordop_edit.detail_organization=ordop_edit.data.participantes;
                // this.dts_ordop_edit.lakes=[];
                this.dts_ordop_edit.middle=ordop_edit.data.medios;
                this.dts_ordop_edit.comunication=ordop_edit.data.comunicaciones;
                this.dts_ordop_edit.execution=ordop_edit.data.ejecucion;
                this.dts_ordop_edit.coordinacion=ordop_edit.data.coordinacion;
                this.btn_r_ordop_edit = false;
                this.time_init_aux=null;
                this.person_selecteds_ordop_edit=ordop_edit.data.personal_lista;
                this.lake_select_edit=ordop_edit.data.lakes;
            }
            else{
                toastr.info(`La Ordop esta fuera de plazo para su modificacion`, `Advertencia`);
                // this.ordops_persons=[];
            }
        },
        async mCallOrdopsEdit(){
            this.ordops_edit=[];
            let res_ordops=await axios.get(`getOrdopsList/${this.captain_ordop}?api_token=${Vue.auth.getToken()}`);
            if(res_ordops.data.length > 0){
                this.ordops_edit=res_ordops.data;
            }else{
                toastr.info(`No Existe ORDOPS registradas`, `Advretencia`);
                this.ordops_edit=[];
            }
        },
        async mCallOrdopsResultEdit(){
            this.ordops_edit_result=[];
            this.resultsOrdop=[];
            this.animate_button=true;
            console.log()
            let rsoi=await axios.get(`getOrdopsAnexo/${this.year_select_a}/${this.captain_ordop_edit}?api_token=${Vue.auth.getToken()}`);
                console.log(rsoi);
            let dtsTemp=rsoi.data;
            if(dtsTemp.length > 0){
                this.ordops_edit_result=dtsTemp;
            }else{
                toastr.info(`No Existe ORDOPS registradas`, `Advretencia`);
                this.ordops=[];
            }
            setTimeout(() => {
                this.animate_button=false;
            }, 2000);
        },
        async mCallResults(){
            // llamamos a los resultados de las ordops
            this.resultsOrdop=[];
            this.process_ordop_edit.id=0;
            if(this.ordop_select_edit_result > 0){
                let ror=await axios.get(`getListDtsResult/${this.ordop_select_edit_result}?api_token=${Vue.auth.getToken()}`);
                console.log(ror);
                let tempResults=ror.data;
                if(tempResults.length > 0){
                    this.resultsOrdop=ror.data;
                    // this.callPersonsOrdop();
                }else{
                    toastr.warning(`No existe Resultados registradas para la Ordop <b>${this.ordop_master.detail}</b>`, 'Informacion');
                }
                
            }else{
                toastr.warning('Seleccione una ordop Inicial', 'Advertencia');
            }
        },
        async mCallDtsResult(){
            try {
                this.ordop_select_result;
                let ror=await axios.get(`getDtsResult/${this.ordop_select_result}?api_token=${Vue.auth.getToken()}`);
                // console.log(ror);
                let tempResults=ror.data;
                if(tempResults.length > 0){
                    // aqui vaciar los datos en la caja                   
                    this.process_ordop_edit.id=this.ordop_select_result;
                    this.process_ordop_edit.type_task=tempResults[0].tipo_resultado;
                    this.process_ordop_edit.done=tempResults[0].hecho;
                    this.process_ordop_edit.causes=tempResults[0].causas;
                    this.process_ordop_edit.consequence=tempResults[0].consecuencia;
                    this.process_ordop_edit.actions_taken=tempResults[0].acciones_tomadas;
                    this.process_ordop_edit.conclusions=tempResults[0].conclusiones;
                    // this.callPersonsOrdop();
                }else{
                    toastr.warning(`No existe Resultados registradas para la Ordop Seleccionada`, 'Informacion');
                }
            } catch (error) {
                console.log(error)
            }
            console.log('llamando al resultado')
        }
    },
    computed:{
        cHoraMilitaryEdit(){
            // return this.$dateMilitary(this.dts_ordop.date_init, this.dts_ordop.time_init);
            try {
                let auxTime=this.dts_ordop_edit.date_init.split('T');
                let ah=this.time_init_aux_edit.split('T');
                let ah2=ah[1].split(':');
                
                return this.$dateMilitary(auxTime[0], `${ah2[0]}:${ah2[1]}`);
            } catch (error) {
                console.log(error);
            }
        },
        cHoraMilitaryInit(){
            // return this.$dateMilitary(this.dts_ordop.date_init, this.dts_ordop.time_init);
            try {
                let auxTime=this.dts_ordop.date_init.split('T');
                let ah=this.time_init_aux.split('T');
                let ah2=ah[1].split(':');
                
                return this.$dateMilitary(auxTime[0], `${ah2[0]}:${ah2[1]}`);
            } catch (error) {
                console.log(error);
            }
        },
        cDtsUser(){
            return this.$store.getters.getUserState;
        },
        listOne() {
          return this.items.filter((item) => item.list === 1)
        },
        listTwo() {
            return this.items.filter((item) => item.list === 2)
        },
    },
    watch:{
        port_query(newQuery){
            axios.get(`searchPort/${newQuery}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {
                    // console.log(res.data)
                    this.portsRegister = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })               
        },
        load_ordop(newLoad){
            // console.log(newLoad.length)
            if(newLoad.length > 0){
            // axios.get(`searchLoad/${newLoad}`)
            axios.get(`searchLoad/${newLoad}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {
                    
                    this.loads_type = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })
            }else{
                // this.c_efectiva_persons=false;
                // this.c_efectiva_load_rodada=false;
                // this.c_efectiva_load_kilo=false;
                // this.c_efectiva_load_litro=false;
                
            }
        }        
    },    
    components:{
        'modal-loading':modalLoading
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            value=value.toLowerCase();
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.divText{
    /* background:red; */
/* height:100px;
width:100px; */
white-space: pre-line;
word-wrap: break-word;
text-align: justify;
}

.required-text{
    color:red; 
    font-weight:bold;
}
</style>



// WEBPACK FOOTER //
// src/components/ordop/ordop.vue